<template>
  <div :class="modal ? 'okvir-modal' : 'okvir'">
    <add-associate ref="addAssociate"
      @success="onAssociateAdded"></add-associate>
    <v-overlay v-if="loading"
      :absolute="absolute"
      :opacity="opacity"
      :value="overlay"
      style="z-index: 100">
      <div v-if="loading"
        class="text-center"
        style="
          position: absolute;
          z-index: 101;
          top: 50%;
          -ms-transform: translateY(-50%);
          transform: translateY(-50%);
        ">
        <v-progress-circular indeterminate
          size="86"
          color="primary">
        </v-progress-circular>
      </div>
    </v-overlay>
    <div class="resizable"
      :style="modal
        ? 'text-align: center; border-radius: 25px !important;'
        : `text-align: center;margin-left: ${margin}`
        ">
      <v-card tile
        color="white"
        class="pb-0 mb-0"
        :style="modal ? 'border-radius: 25px !important' : ''">
        <v-card-title v-if="modal"
          class="d-flex"
          style="
            vertical-align: middle;
            background-color: #1577da;

            height: 58px;
            color: white;
          ">
          <span class="text-h5"
            style="font-weight: bold">{{ title }}</span>
        </v-card-title>

        <!-- Header Filters -->
        <div class="table-header-filters">
          <v-form ref="primkaForm" @submit.prevent="submit">
            <v-row dense class="align-center">
              <v-col v-if="locations.length > 1" cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  v-model="selectedLocation"
                  :items="locations"
                  item-text="name"
                  item-value="value"
                  label="Prodajno mjesto"
                  return-object
                  dense
                  outlined
                  hide-details
                  class="filter-select"
                  :rules="[rules.req]"
                  :disabled="akcija === 'update'"
                  @change="getWarehouses()">
                </v-autocomplete>
              </v-col>

              <v-col v-if="warehouses.length > 1" cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  v-model="selectedWarehouse"
                  :items="warehouses"
                  item-text="name"
                  item-value="value"
                  label="Skladište"
                  return-object
                  dense
                  outlined
                  hide-details
                  class="filter-select"
                  :rules="[rules.req]"
                  :disabled="akcija === 'update'"
                  @change="onWarehouseChange">
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  v-model="selectedDobavljac"
                  :items="dobavljaciWithAddOption"
                  item-text="name"
                  item-value="value"
                  label="Dobavljač"
                  return-object
                  dense
                  outlined
                  hide-details
                  class="filter-select"
                  :rules="[rules.req]"
                  :disabled="akcija === 'update'"
                  :search-input.sync="dobavljacSearchInput"
                  :loading="loadingDobavljac"
                  clearable
                  placeholder="POČNITE TIPKATI ZA PRETRAGU"
                  :no-filter="false"
                  @change="onDobavljacChange">
                  <template v-slot:no-data>
                    <v-list-item
                      v-if="dobavljacSearchInput && dobavljacSearchInput.trim().length >= 3 && !loadingDobavljac"
                      @click="openAddAssociate"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon small color="primary" class="mr-2">mdi-plus-circle</v-icon>
                          <span class="primary--text font-weight-bold">Dodaj novog dobavljača</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content v-if="item.value === 'add-new'">
                      <v-list-item-title>
                        <v-icon small color="primary" class="mr-2">mdi-plus-circle</v-icon>
                        <span class="primary--text font-weight-bold">{{ item.name }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content v-else>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="2" md="1">
                <v-autocomplete
                  v-model="selectedNAcinPlacanja"
                  :items="nacinplacanja"
                  item-text="name"
                  item-value="value"
                  label="Način plaćanja"
                  return-object
                  dense
                  outlined
                  hide-details
                  class="filter-select"
                  :rules="[rules.req]">
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="2" md="1">
                <date-picker
                  ref="datepicker"
                  v-model="invoiceDate"
                  :clearable="false"
                  prefix-class="xmx"
                  class="datetimepicker filter-select"
                  placeholder="Datum"
                  type="date"
                  valueType="timestamp"
                  format="DD.MM.YYYY"
                  :default-value="new Date()"
                  :popup-style="{ zIndex: 9999 }"
                  :disabled-date="disableFutureDates"
                  :rules="[rules.req]"
                  :append-to-body="true">
                </date-picker>
              </v-col>

              <v-col cols="12" sm="6" md="2" lg="2">
                <v-text-field
                  v-model="brojTemelja"
                  label="Broj temelja"
                  dense
                  outlined
                  hide-details
                  class="filter-select"
                  :rules="[rules.req]">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="3" md="1" lg="1">
                <v-text-field
                  v-model="interniBrojPrimke"
                  label="Broj primke"
                  type="number"
                  dense
                  outlined
                  hide-details
                  class="filter-select"
                  :rules="[rules.req, rules.positive]"
                  readonly
                  @input="validateIntegerInput">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="4" md="2">
                <div class="d-flex align-center">
                  <v-select
                    v-model="rabatCalcType"
                    :items="rabatCalcTypes"
                    item-text="name"
                    item-value="value"
                    label="Izračun rabata"
                    :disabled="isDisableRabatChange()"
                    dense
                    outlined
                    hide-details
                    class="filter-select"
                    style="flex: 1;">
                  </v-select>
                  <v-btn
                    icon
                    small
                    class="ml-1"
                    @click="showRabatInfoModal = true">
                    <v-icon small color="primary">mdi-help-circle-outline</v-icon>
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="12" sm="4" md="2">
                <div class="d-flex align-center">
                  <v-select
                    v-model="porezCalcType"
                    :items="porezCalcTypes"
                    item-text="name"
                    item-value="value"
                    label="Izračun poreza"
                    dense
                    outlined
                    hide-details
                    class="filter-select"
                    style="flex: 1;"
                    @change="recalculate()">
                  </v-select>
                  <v-btn
                    icon
                    small
                    class="ml-1"
                    @click="showPorezInfoModal = true">
                    <v-icon small color="primary">mdi-help-circle-outline</v-icon>
                  </v-btn>
                </div>
              </v-col>

              <!-- Search Field in Header -->
              <v-col cols="12" class="pt-2 search-in-header">
                <v-text-field
                  ref="searchField"
                  v-model="searchQuery"
                  label="Traži artikl (šifra ili naziv)"
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  dense
                  clearable
                  hide-details
                  class="filter-select"
                  @input="performTrigramSearch"
                  @keydown.enter.prevent="selectFirstResult"
                  @keydown.down.prevent="navigateResults('down')"
                  @keydown.up.prevent="navigateResults('up')"
                  @keydown.esc="clearSearch"
                >
                  <template #append>
                    <v-icon v-if="searchLoading" small>mdi-loading mdi-spin</v-icon>
                  </template>
                </v-text-field>

                <!-- Search Results Dropdown -->
                <v-list v-if="searchResults.length > 0" class="search-results elevation-4">
                  <!-- Header row with labels -->
                  <v-list-item class="search-results-header">
                    <v-list-item-content class="py-1">
                      <v-row align="center" no-gutters>
                        <v-col cols="5" class="pr-2 text-left">
                          <div class="text-caption font-weight-bold text--secondary">Naziv</div>
                        </v-col>
                        <v-col cols="2" class="text-center">
                          <div class="text-caption font-weight-bold text--secondary">Šifra</div>
                        </v-col>
                        <v-col cols="2" class="text-right pr-3">
                          <div class="text-caption font-weight-bold text--secondary">Cijena</div>
                        </v-col>
                        <v-col cols="2" class="text-center">
                          <div class="text-caption font-weight-bold text--secondary">JM</div>
                        </v-col>
                        <v-col cols="1" class="text-right">
                          <div class="text-caption font-weight-bold text--secondary">Zaliha</div>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>

                  <!-- Data rows -->
                  <v-list-item
                    v-for="(item, idx) in searchResults"
                    :key="item.id"
                    :class="{ 'result-selected': selectedResultIndex === idx }"
                    @click="openModalForItem(item)"
                    class="search-result-item"
                  >
                    <v-list-item-content class="py-1">
                      <v-row align="center" no-gutters>
                        <v-col cols="5" class="pr-2 text-left">
                          <div class="text-body-2 font-weight-medium">{{ item.item.name }}</div>
                        </v-col>
                        <v-col cols="2" class="text-center">
                          <div class="text-caption text--secondary">{{ item.item.code || '-' }}</div>
                        </v-col>
                        <v-col cols="2" class="text-right pr-3">
                          <div class="text-body-2 font-weight-medium primary--text">
                            {{ getItemPrice(item) }}
                          </div>
                        </v-col>
                        <v-col cols="2" class="text-center">
                          <div class="text-caption text--secondary">
                            {{ getItemUnit(item) }}
                          </div>
                        </v-col>
                        <v-col cols="1" class="text-right">
                          <div class="text-caption" :class="item.item.stock > 0 ? 'success--text' : 'error--text'">
                            {{ formatStock(item.item.stock) }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <!-- No results message - positioned absolutely -->
                <div v-if="showNoResults" class="no-results-overlay">
                  <v-alert
                    type="info"
                    dense
                    text
                    class="mb-0">
                    Nema rezultata za "{{ searchQuery }}"
                  </v-alert>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </div>

        <!-- Items List -->
        <div class="items-list mt-1">
          <!-- Header Row with Info Button -->
          <div v-if="items.length > 0" class="items-header-wrapper d-flex align-center mb-2">
            <div class="items-header px-3 py-2 flex-grow-1">
            <v-row dense align="center" no-gutters>
              <v-col cols="1" class="text-left pr-1">
                <span class="text-caption font-weight-bold text--secondary">RB</span>
              </v-col>
              <v-col cols="4" class="pr-2 text-left">
                <span class="text-caption font-weight-bold text--secondary">Artikl</span>
              </v-col>
              <v-col cols="1" class="text-center">
                <span class="text-caption font-weight-bold text--secondary">Količina</span>
              </v-col>
              <v-col cols="1" class="text-right">
                <span class="text-caption font-weight-bold text--secondary">Jed. cijena</span>
              </v-col>
              <v-col cols="1" class="text-right">
                <span class="text-caption font-weight-bold text--secondary">Rabat %</span>
              </v-col>
              <v-col cols="1" class="text-right">
                <span class="text-caption font-weight-bold text--secondary">PDV %</span>
              </v-col>
              <v-col cols="1" class="text-right pl-3">
                <span class="text-caption font-weight-bold text--secondary">Ukupno</span>
              </v-col>
              <v-col cols="1" class="text-right pl-2">
                <span class="text-caption font-weight-bold text--secondary">Ukupno s PDV</span>
              </v-col>
              <v-col cols="1" class="text-right pl-3">
                <span class="text-caption font-weight-bold text--secondary"></span>
              </v-col>
            </v-row>
            </div>
          </div>

          <!-- Items -->
          <v-card v-for="(item, index) in items"
            :key="index"
            :class="['item-row mb-1 elevation-1', { 'item-row-selected': selectedItemIndex === index }]"
            @click="editItem(index)">
            <v-card-text class="py-1 px-3">
              <v-row dense align="center" no-gutters>
                <v-col cols="1" class="text-left pr-1">
                  <span class="font-weight-bold text-body-2 text--secondary">{{ index + 1 }}.</span>
                </v-col>
                <v-col cols="4" class="pr-2 text-left">
                  <span class="font-weight-medium text-body-2">{{ item.artikl }}</span>
                  <span class="text-caption text--secondary ml-2">({{ item.code || '-' }})</span>
                </v-col>
                <v-col cols="1" class="text-center">
                  <span class="text-body-2">{{ formatNumber(item.kolicina) }} {{ item.mjernaJedinicaNaziv }}</span>
                </v-col>
                <v-col cols="1" class="text-right">
                  <span class="text-body-2">{{ formatCurrency(item.jedinicnaCijenaBezPdv) }}</span>
                </v-col>
                <v-col cols="1" class="text-right">
                  <span class="text-caption">{{ item.rabat || 0 }}%</span>
                </v-col>
                <v-col cols="1" class="text-right">
                  <span class="text-caption">{{ item.stopaPdv }}%</span>
                </v-col>
                <v-col cols="1" class="text-right pl-3">
                  <span class="text-body-2">{{ formatCurrency(item.ukupnaCijenaBezPdv) }}</span>
                </v-col>
                <v-col cols="1" class="text-right pl-2">
                  <span class="font-weight-bold primary--text">{{ formatCurrency(item.ukupnaCijenaSPdv) }}</span>
                </v-col>
                <v-col cols="1" class="d-flex justify-end align-center pr-0 pl-3">
                  <v-btn icon small class="kalkulacija-delete-btn" @click.stop="deleteItem(index)" elevation="0">
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Empty state -->
          <v-alert v-if="items.length === 0"
            type="info"
            text
            dense
            class="mt-4">
            Nema dodanih artikala. Pretražite i kliknite na artikl za dodavanje.
          </v-alert>

        </div>

        <!-- Item Entry Modal -->
        <v-dialog v-model="itemModal" max-width="800px" persistent @keydown.enter.prevent="saveItem" @keydown.esc="closeItemModal">
          <v-card class="modal-glass-card modal-fixed-layout">
            <v-card-title class="modal-gradient-header modal-fixed-header">
              <span class="text-h6 white--text">{{ editingIndex !== null ? 'Uredi artikl' : 'Dodaj artikl' }}</span>
            </v-card-title>

            <v-card-text class="pt-4 modal-scrollable-content">
              <v-row dense>
                <!-- Artikl Info -->
                <v-col cols="12">
                  <v-row dense align="center">
                    <v-col cols="12" sm="8">
                      <div class="text-h6 mb-2">{{ currentItem.artikl }}</div>
                      <div class="text-subtitle-2 text--secondary">
                        Šifra: {{ currentItem.code || '-' }} | Zaliha: {{ formatStock(currentItem.stock) }}
                        <span v-if="currentItem.lastPrice"> | Zadnja cijena: {{ formatCurrency(currentItem.lastPrice) }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4" class="text-right">
                      <v-switch
                        v-model="manualInputMode"
                        color="primary"
                        dense
                        hide-details
                        class="mt-0 d-inline-flex"
                      >
                        <template v-slot:label>
                          <div class="text-body-2">
                            Ručni unos
                            <div class="text-caption text--secondary">(bez auto kalkulacije)</div>
                          </div>
                        </template>
                      </v-switch>
                    </v-col>
                  </v-row>
                  <v-divider class="my-3"></v-divider>
                </v-col>

                <!-- Red 1: Količina, Cijena bez PDV, Cijena s PDV -->
                <v-col cols="12" sm="4">
                  <v-text-field
                    ref="kolicinaField"
                    v-model="currentItem.kolicina"
                    label="Količina *"
                    type="text"
                    inputmode="decimal"
                    outlined
                    dense
                    :rules="[rules.req]"
                    @input="normalizeDecimalInput('kolicina', calculateItemTotals)"
                    @keydown.native="handleCommaKeydown($event, 'kolicina')"
                    @focus="selectAllOnFocus"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="currentItem.jedinicnaCijenaBezPdv"
                    label="Cijena bez PDV *"
                    type="text"
                    inputmode="decimal"
                    outlined
                    dense
                    prefix="€"
                    :rules="[rules.req]"
                    @input="normalizeDecimalInput('jedinicnaCijenaBezPdv', calculateItemTotals)"
                    @keydown.native="handleCommaKeydown($event, 'jedinicnaCijenaBezPdv')"
                    @focus="selectAllOnFocus"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="currentItem.jedinicnaCijenaSPdv"
                    label="Cijena s PDV"
                    type="text"
                    inputmode="decimal"
                    outlined
                    dense
                    prefix="€"
                    @input="normalizeDecimalInput('jedinicnaCijenaSPdv', calculateFromPriceWithPdv)"
                    @keydown.native="handleCommaKeydown($event, 'jedinicnaCijenaSPdv')"
                    @focus="selectAllOnFocus"
                  ></v-text-field>
                </v-col>

                <!-- Red 2: Rabat, PDV stopa, Mjerna jedinica -->
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="currentItem.rabat"
                    label="Rabat %"
                    type="text"
                    inputmode="decimal"
                    outlined
                    dense
                    suffix="%"
                    @input="normalizeDecimalInput('rabat', calculateItemTotals)"
                    @keydown.native="handleCommaKeydown($event, 'rabat')"
                    @focus="selectAllOnFocus"
                  ></v-text-field>
                  <div class="text-caption text--secondary mt-n2 ml-3">
                    <v-icon x-small color="primary">mdi-information-outline</v-icon>
                    {{ rabatCalcType === 1 ? 'Rabat na jediničnu cijenu' : 'Rabat na ukupnu cijenu' }}
                  </div>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-select
                    v-model="currentItem.stopaPdv"
                    :items="pdvRates"
                    label="PDV stopa *"
                    outlined
                    dense
                    suffix="%"
                    :rules="[rules.req]"
                    @change="!manualInputMode && calculateItemTotals()"
                  ></v-select>
                  <div class="text-caption text--secondary mt-n2 ml-3">
                    <v-icon x-small color="primary">mdi-information-outline</v-icon>
                    {{ porezCalcType === 1 ? 'Porez se računa po artiklima' : 'Porez se računa po ukupnoj cijeni' }}
                  </div>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-select
                    v-model="currentItem.mjernaJedinica"
                    :items="currentItem.availableUnits"
                    item-text="name"
                    item-value="id"
                    label="Mjerna jedinica *"
                    outlined
                    dense
                    :rules="[rules.req]"
                    @change="onUnitChange"
                  ></v-select>
                </v-col>

                <!-- Maloprodajna cijena (informativno) -->
                <v-col v-if="currentItem.retailPriceWithoutPdv !== null" cols="12">
                  <v-divider class="my-2"></v-divider>
                  <div class="text-subtitle-2 mb-2">
                    <v-icon small color="info" class="mr-1">mdi-information-outline</v-icon>
                    Maloprodajna cijena (informativno)
                  </div>
                </v-col>

                <v-col v-if="currentItem.retailPriceWithoutPdv !== null" cols="12" sm="4">
                  <v-text-field
                    :value="formatRetailPrice(currentItem.retailPriceWithoutPdv)"
                    label="Maloprodajna cijena bez PDV"
                    outlined
                    dense
                    readonly
                    suffix="€"
                    hide-details
                    class="retail-price-field"
                  ></v-text-field>
                </v-col>

                <v-col v-if="currentItem.retailPriceWithPdv !== null" cols="12" sm="4">
                  <v-text-field
                    :value="formatRetailPrice(currentItem.retailPriceWithPdv)"
                    label="Maloprodajna cijena s PDV"
                    outlined
                    dense
                    readonly
                    suffix="€"
                    hide-details
                    class="retail-price-field"
                  ></v-text-field>
                </v-col>

                <v-col v-if="currentItem.retailPriceTaxRate !== null" cols="12" sm="4">
                  <v-text-field
                    :value="currentItem.retailPriceTaxRate"
                    label="PDV stopa"
                    outlined
                    dense
                    readonly
                    suffix="%"
                    hide-details
                    class="retail-price-field"
                  ></v-text-field>
                </v-col>

                <!-- Marža -->
                <v-col v-if="marginAmount !== null" cols="12">
                  <v-divider class="my-2"></v-divider>
                  <div class="text-subtitle-2 mb-2">
                    <v-icon small color="success" class="mr-1">mdi-chart-line</v-icon>
                    Marža
                  </div>
                </v-col>

                <v-col v-if="marginAmount !== null" cols="12" sm="6">
                  <v-text-field
                    :value="formatRetailPrice(marginAmount)"
                    label="Marža (iznos)"
                    outlined
                    dense
                    readonly
                    suffix="€"
                    hide-details
                    :class="marginAmount >= 0 ? 'margin-positive-field' : 'margin-negative-field'"
                  ></v-text-field>
                </v-col>

                <v-col v-if="marginPercentage !== null" cols="12" sm="6">
                  <v-text-field
                    :value="formatRetailPrice(marginPercentage)"
                    label="Marža (%)"
                    outlined
                    dense
                    readonly
                    suffix="%"
                    hide-details
                    :class="marginPercentage >= 0 ? 'margin-positive-field' : 'margin-negative-field'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-divider class="my-2"></v-divider>
                </v-col>

                <!-- Calculated totals -->
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-if="manualInputMode"
                    v-model="currentItem.ukupnaCijenaBezPdv"
                    label="Ukupno bez PDV"
                    type="number"
                    step="0.01"
                    outlined
                    dense
                    prefix="€"
                    @focus="selectAllOnFocus"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    :value="formatCurrency(currentItem.ukupnaCijenaBezPdv)"
                    label="Ukupno bez PDV"
                    outlined
                    dense
                    readonly
                    filled
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-text-field
                    v-if="manualInputMode"
                    v-model="currentItem.iznosPdv"
                    label="Iznos PDV"
                    type="number"
                    step="0.01"
                    outlined
                    dense
                    prefix="€"
                    @focus="selectAllOnFocus"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    :value="formatCurrency(currentItem.iznosPdv)"
                    label="Iznos PDV"
                    outlined
                    dense
                    readonly
                    filled
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-text-field
                    v-if="manualInputMode"
                    v-model="currentItem.ukupnaCijenaSPdv"
                    label="Ukupno s PDV"
                    type="number"
                    step="0.01"
                    outlined
                    dense
                    prefix="€"
                    class="font-weight-bold"
                    @focus="selectAllOnFocus"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    :value="formatCurrency(currentItem.ukupnaCijenaSPdv)"
                    label="Ukupno s PDV"
                    outlined
                    dense
                    readonly
                    filled
                    class="font-weight-bold"
                  ></v-text-field>
                </v-col>

                <!-- Povratna naknada -->
                <v-col v-if="hasPovratnaNaknada" cols="12">
                  <v-divider class="my-2"></v-divider>
                </v-col>

                <v-col v-if="hasPovratnaNaknada" cols="12" sm="6">
                  <v-text-field
                    v-if="manualInputMode"
                    v-model="currentItem.povratnaNaknadaIznos"
                    label="Povratna naknada (ukupno)"
                    type="number"
                    step="0.01"
                    outlined
                    dense
                    prefix="€"
                    hint="Ručni unos - unesite iznos"
                    persistent-hint
                    @focus="selectAllOnFocus"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small color="orange darken-1">mdi-package-variant</v-icon>
                    </template>
                  </v-text-field>
                  <v-text-field
                    v-else
                    :value="formatCurrency(currentItem.povratnaNaknadaIznos)"
                    label="Povratna naknada (ukupno)"
                    outlined
                    dense
                    readonly
                    filled
                    hint="Auto-kalkulirano: količina × naknada po jedinici"
                    persistent-hint
                    class="orange--text text--darken-1"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small color="orange darken-1">mdi-package-variant</v-icon>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col v-if="hasPovratnaNaknada && !manualInputMode" cols="12" sm="6">
                  <v-alert type="info" dense text class="mb-0">
                    <div class="text-caption">
                      <strong>Iznos po jedinici:</strong> {{ formatCurrency(povratnaNaknadaAmountPerUnit) }}<br>
                      <strong>Količina:</strong> {{ formatNumber(currentItem.kolicina || 0) }}<br>
                      <strong>Ukupno:</strong> {{ formatCurrency(currentItem.povratnaNaknadaIznos || 0) }}
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="pa-4 modal-fixed-footer">
              <v-spacer></v-spacer>
              <v-btn class="modal-cancel-btn" @click="closeItemModal">Odustani</v-btn>
              <v-btn class="modal-save-btn" @click="saveItem">
                <v-icon small class="mr-1">mdi-content-save</v-icon>
                Spremi
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-card-actions class="fixed-actions">
          <v-row class="ma-0 align-center">
            <!-- Totals - Left Side -->
            <v-col v-if="items.length > 0" cols="auto" class="d-flex align-center pa-2">
              <div class="totals-inline d-flex align-center">
                <!-- Ručni unos switch -->
                <div class="mr-3 d-flex align-center">
                  <v-switch
                    v-model="manualTotalsMode"
                    color="orange"
                    dense
                    hide-details
                    class="mt-0"
                    @change="toggleManualTotalsMode"
                  >
                    <template v-slot:label>
                      <div class="text-caption" style="white-space: nowrap;">
                        <v-icon small color="orange" class="mr-1">mdi-pencil</v-icon>
                        Ručni unos
                      </div>
                    </template>
                  </v-switch>
                </div>

                <v-divider vertical class="mx-2" style="height: 50px;"></v-divider>

                <!-- Ukupno bez PDV -->
                <div class="total-box mr-3">
                  <div class="total-label">Ukupno bez PDV</div>
                  <v-text-field
                    v-if="manualTotalsMode"
                    v-model="manualTotalBezPdv"
                    type="number"
                    step="0.01"
                    dense
                    outlined
                    hide-details
                    prefix="€"
                    class="manual-total-input"
                    style="max-width: 150px;"
                    @focus="selectAllOnFocus"
                  ></v-text-field>
                  <div v-else class="total-value">{{ formatCurrency(totalBezPdv) }}</div>
                </div>

                <!-- PDV -->
                <div class="total-box mr-3">
                  <div class="total-label">PDV</div>
                  <v-text-field
                    v-if="manualTotalsMode"
                    v-model="manualTotalPdv"
                    type="number"
                    step="0.01"
                    dense
                    outlined
                    hide-details
                    prefix="€"
                    class="manual-total-input"
                    style="max-width: 150px;"
                    @focus="selectAllOnFocus"
                  ></v-text-field>
                  <div v-else class="total-value">{{ formatCurrency(totalPdv) }}</div>
                </div>

                <v-divider vertical class="mx-2" style="height: 50px;"></v-divider>

                <!-- UKUPNO s PDV -->
                <div class="total-box total-box-main">
                  <div class="total-label-main">UKUPNO</div>
                  <v-text-field
                    v-if="manualTotalsMode"
                    v-model="manualTotalSPdv"
                    type="number"
                    step="0.01"
                    dense
                    outlined
                    hide-details
                    prefix="€"
                    class="manual-total-input font-weight-bold"
                    style="max-width: 150px;"
                    @focus="selectAllOnFocus"
                  ></v-text-field>
                  <div v-else class="total-value-main">{{ formatCurrency(totalSPdv) }}</div>
                </div>

                <!-- Povratna Naknada Info - Inline -->
                <template v-if="povratnaNaknadaCalculation.hasPN">
                  <v-divider vertical class="mx-2" style="height: 50px;"></v-divider>
                  <div class="total-box total-box-warning">
                    <div class="total-label">
                      <v-icon small color="orange darken-1" class="mr-1">mdi-package-variant</v-icon>
                      Povratna naknada · {{ formatNumber(povratnaNaknadaCalculation.totalQuantity) }} kom
                    </div>
                    <div class="total-value">
                      {{ formatCurrency(povratnaNaknadaCalculation.totalAmount) }}
                    </div>
                  </div>
                </template>
              </div>
            </v-col>

            <!-- Financial Info Button -->
            <v-col v-if="items.length > 0" cols="auto" class="pa-2">
              <v-btn
                icon
                small
                color="teal"
                outlined
                @click="showFinancialSummaryModal = true"
              >
                <v-icon small>mdi-calculator</v-icon>
              </v-btn>
            </v-col>

            <v-spacer></v-spacer>

            <!-- Buttons - Right Side -->
            <v-col cols="auto" class="d-flex justify-end align-center pa-2">
              <v-btn
                class="kalkulacija-danger-btn mr-2"
                @click="clearData"
                @touchstart="clearData"
                elevation="0">
                <v-icon left small>mdi-delete-outline</v-icon>
                Obriši sve
              </v-btn>
              <v-btn
                v-if="modal"
                class="kalkulacija-cancel-btn mr-2"
                @click="closeModal()"
                @touchstart="closeModal()"
                elevation="0">
                <v-icon left small>mdi-close</v-icon>
                Odustani
              </v-btn>
              <v-btn
                v-if="!modal"
                class="kalkulacija-cancel-btn mr-2"
                @click="cancelAndGoBack"
                @touchstart="cancelAndGoBack"
                elevation="0">
                <v-icon left small>mdi-close</v-icon>
                Odustani
              </v-btn>
              <v-btn
                class="kalkulacija-success-btn"
                @click="presubmit"
                @touchstart="presubmit"
                elevation="0">
                <v-icon left small>mdi-content-save</v-icon>
                Spremi
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
    <modal v-if="!modal"
      :clickToClose="false"
      height="auto"
      width="90%"
      scrollable
      draggable
      resizable
      style="z-index: 50"
      name="primke"
      class="myTest">
      <Dokumenti name="dokument"
        :modal="true"
        @closeModal="hideDoc()"></Dokumenti>
    </modal>

    <!-- Rabat Info Modal -->
    <v-dialog v-model="showRabatInfoModal" max-width="600px">
      <v-card class="modal-glass-card">
        <v-card-title class="modal-gradient-header">
          <span class="text-h6 white--text">Izračun rabata - Objašnjenje</span>
        </v-card-title>

        <v-card-text class="pa-6">
          <div class="mb-4">
            <h3 class="text-subtitle-1 font-weight-bold mb-2 primary--text">S jediničnom cijenom</h3>
            <p class="mb-2">Rabat se primjenjuje na jediničnu cijenu, zaokruži se, zatim množi s količinom.</p>
            <div class="grey lighten-4 pa-3 rounded">
              <strong>Formula:</strong><br>
              1. Jedinična cijena s rabatom = ZAOKRUŽI(Jedinična cijena × (1 - Rabat%/100), 2 decimale)<br>
              2. Ukupno bez PDV = ZAOKRUŽI(Jedinična cijena s rabatom × Količina, 2 decimale)<br><br>
              <strong>Primjer 1:</strong><br>
              Jedinična cijena: 100€, Rabat: 10%, Količina: 5<br>
              → 100€ × 0.90 = 90.00€ (zaokruženo)<br>
              → 90.00€ × 5 = 450.00€ (zaokruženo)<br><br>
              <strong>Primjer 2:</strong><br>
              Jedinična cijena: 1.12€, Rabat: 10%, Količina: 36<br>
              → 1.12€ × 0.90 = 1.008€ → <strong>1.01€</strong> (zaokruženo)<br>
              → 1.01€ × 36 = 36.36€ (zaokruženo)
            </div>
          </div>

          <v-divider class="my-4"></v-divider>

          <div>
            <h3 class="text-subtitle-1 font-weight-bold mb-2 primary--text">S ukupnom cijenom</h3>
            <p class="mb-2">Prvo se izračuna ukupna cijena i zaokruži, zatim se rabat primjenjuje na zaokruženi ukupan iznos.</p>
            <div class="grey lighten-4 pa-3 rounded">
              <strong>Formula:</strong><br>
              1. Ukupno bez rabata = ZAOKRUŽI(Jedinična cijena × Količina, 2 decimale)<br>
              2. Ukupno s rabatom = ZAOKRUŽI(Ukupno bez rabata × (1 - Rabat%/100), 2 decimale)<br><br>
              <strong>Primjer 1:</strong><br>
              Jedinična cijena: 100€, Količina: 5, Rabat: 10%<br>
              → 100€ × 5 = 500.00€ (zaokruženo)<br>
              → 500.00€ × 0.90 = 450.00€ (zaokruženo)<br><br>
              <strong>Primjer 2:</strong><br>
              Jedinična cijena: 10.556€, Količina: 3, Rabat: 10%<br>
              → 10.556€ × 3 = 31.668€ → <strong>31.67€</strong> (zaokruženo)<br>
              → 31.67€ × 0.90 = 28.503€ → <strong>28.50€</strong> (zaokruženo)
            </div>
          </div>

          <v-alert type="info" dense text class="mt-4">
            <small><strong>Važno:</strong> Zaokruživanje u svakom koraku kod metode "S ukupnom cijenom" može dati drugačiji rezultat od metode "S jediničnom cijenom" zbog efekta akumulacije zaokruživanja.</small>
          </v-alert>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn class="modal-save-btn" @click="showRabatInfoModal = false">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Razumijem
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Porez Info Modal -->
    <v-dialog v-model="showPorezInfoModal" max-width="600px">
      <v-card class="modal-glass-card">
        <v-card-title class="modal-gradient-header">
          <span class="text-h6 white--text">Izračun poreza - Objašnjenje</span>
        </v-card-title>

        <v-card-text class="pa-6">
          <div class="mb-4">
            <h3 class="text-subtitle-1 font-weight-bold mb-2 primary--text">Po artiklima</h3>
            <p class="mb-2">PDV se izračunava za svaki artikl pojedinačno na temelju njegove PDV stope.</p>
            <div class="grey lighten-4 pa-3 rounded">
              <strong>Formula:</strong><br>
              Za svaki artikl: PDV = Cijena bez PDV × (PDV stopa / 100)<br>
              Ukupan PDV = Zbroj svih PDV iznosa<br><br>
              <strong>Primjer:</strong><br>
              Artikl 1: 100€ × 25% = 25€ PDV<br>
              Artikl 2: 200€ × 13% = 26€ PDV<br>
              → Ukupan PDV: 51€
            </div>
          </div>

          <v-divider class="my-4"></v-divider>

          <div>
            <h3 class="text-subtitle-1 font-weight-bold mb-2 primary--text">Po ukupnoj cijeni</h3>
            <p class="mb-2">Prvo se zbroji ukupna cijena svih artikala, zatim se PDV primjenjuje na ukupan iznos.</p>
            <div class="grey lighten-4 pa-3 rounded">
              <strong>Formula:</strong><br>
              Ukupno bez PDV = Suma svih artikala<br>
              PDV = Ukupno bez PDV × (prosječna PDV stopa / 100)<br><br>
              <strong>Napomena:</strong><br>
              Ova metoda se koristi kada je potrebno izračunati PDV na ukupan iznos primke,
              neovisno o pojedinačnim PDV stopama artikala.
            </div>
          </div>

          <v-alert type="warning" dense text class="mt-4">
            <small><strong>Važno:</strong> Odabir metode izračuna utječe na preciznost i zaokruživanje PDV iznosa.
            "Po artiklima" daje točniji rezultat za svaki artikl.</small>
          </v-alert>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn class="modal-save-btn" @click="showPorezInfoModal = false">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Razumijem
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Financial Summary Modal -->
    <v-dialog v-model="showFinancialSummaryModal" max-width="700px">
      <v-card class="modal-glass-card financial-summary-modal">
        <v-card-title class="modal-gradient-header financial-summary-header">
          <span class="text-h6 white--text">Financijski pregled</span>
        </v-card-title>

        <v-card-text class="pa-6 financial-summary-content">
          <!-- Ukupna vrijednost -->
          <div class="mb-4">
            <h3 class="text-subtitle-1 font-weight-bold mb-3 primary--text">Ukupna vrijednost (bez rabata)</h3>
            <v-row dense>
              <v-col cols="6">
                <div class="grey lighten-4 pa-3 rounded">
                  <div class="text-caption text--secondary">Bez PDV</div>
                  <div class="text-h6 primary--text font-weight-bold">{{ formatCurrency(financialSummary.totalBeforeDiscountNoPdv) }}</div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="grey lighten-4 pa-3 rounded">
                  <div class="text-caption text--secondary">S PDV</div>
                  <div class="text-h6 primary--text font-weight-bold">{{ formatCurrency(financialSummary.totalBeforeDiscountWithPdv) }}</div>
                </div>
              </v-col>
            </v-row>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Rabati -->
          <div v-if="financialSummary.discountsByRate && Object.keys(financialSummary.discountsByRate).length > 0" class="mb-4">
            <h3 class="text-subtitle-1 font-weight-bold mb-3 primary--text">Rabati po postocima</h3>
            <v-simple-table dense class="grey lighten-4 rounded">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Rabat %</th>
                    <th class="text-right">Iznos rabata</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(amount, rate) in financialSummary.discountsByRate" :key="rate">
                    <td>{{ rate }}%</td>
                    <td class="text-right">{{ formatCurrency(amount) }}</td>
                  </tr>
                  <tr class="font-weight-bold">
                    <td>UKUPNO</td>
                    <td class="text-right primary--text">{{ formatCurrency(financialSummary.totalDiscount) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <v-divider v-if="financialSummary.discountsByRate && Object.keys(financialSummary.discountsByRate).length > 0" class="my-4"></v-divider>

          <!-- PDV -->
          <div class="mb-4">
            <h3 class="text-subtitle-1 font-weight-bold mb-3 primary--text">PDV po stopama</h3>
            <v-simple-table dense class="grey lighten-4 rounded">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">PDV %</th>
                    <th class="text-right">Osnovica</th>
                    <th class="text-right">Iznos PDV</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, rate) in financialSummary.pdvByRate" :key="rate">
                    <td>{{ rate }}%</td>
                    <td class="text-right">{{ formatCurrency(data.base) }}</td>
                    <td class="text-right">{{ formatCurrency(data.amount) }}</td>
                  </tr>
                  <tr class="font-weight-bold">
                    <td>UKUPNO</td>
                    <td class="text-right primary--text">{{ formatCurrency(financialSummary.totalBase) }}</td>
                    <td class="text-right primary--text">{{ formatCurrency(financialSummary.totalPdv) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <!-- Povratna Naknada -->
          <div v-if="povratnaNaknadaCalculation.hasPN" class="mb-4">
            <v-divider class="my-4"></v-divider>
            <h3 class="text-subtitle-1 font-weight-bold mb-3 orange--text text--darken-1">
              <v-icon small color="orange darken-1" class="mr-1">mdi-package-variant</v-icon>
              Povratna naknada
            </h3>
            <v-simple-table dense class="grey lighten-4 rounded mb-3">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Artikl</th>
                    <th class="text-center">Količina</th>
                    <th class="text-right">Cijena/kom</th>
                    <th class="text-right">Ukupno</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(pnItem, idx) in povratnaNaknadaCalculation.items" :key="idx">
                    <td class="text-left">{{ pnItem.artikl }}</td>
                    <td class="text-center">{{ formatNumber(pnItem.quantity) }}</td>
                    <td class="text-right">{{ formatCurrency(pnItem.amountPerUnit) }}</td>
                    <td class="text-right font-weight-medium">{{ formatCurrency(pnItem.subtotal) }}</td>
                  </tr>
                  <tr class="font-weight-bold orange lighten-5">
                    <td colspan="2" class="text-right">UKUPNO:</td>
                    <td class="text-right">{{ formatNumber(povratnaNaknadaCalculation.totalQuantity) }} kom</td>
                    <td class="text-right orange--text text--darken-1">
                      {{ formatCurrency(povratnaNaknadaCalculation.totalAmount) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-alert type="info" dense text>
              <small>
                <v-icon small class="mr-1">mdi-information-outline</v-icon>
                Povratna naknada je automatski izračunata na temelju količine artikala.
              </small>
            </v-alert>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Konačni iznos -->
          <div>
            <v-row dense>
              <v-col cols="12">
                <div class="grey darken-3 pa-4 rounded white--text">
                  <div class="text-caption">Ukupno za uplatu</div>
                  <div class="text-h5 font-weight-bold">{{ formatCurrency(financialSummary.grandTotal) }}</div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-card-actions class="pa-4 financial-summary-footer">
          <v-spacer></v-spacer>
          <v-btn class="modal-save-btn" @click="showFinancialSummaryModal = false">
            <v-icon small class="mr-1">mdi-close</v-icon>
            Zatvori
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Item Mapping Dialog -->
    <ItemMappingDialog
      v-if="showItemMappingDialog && einvoiceData"
      :items="einvoiceData.lines"
      :locations="locations"
      :warehouses="warehouses"
      :initial-location-id="selectedLocation ? selectedLocation.id : null"
      :initial-warehouse-id="selectedWarehouse ? selectedWarehouse.id : null"
      :supplier="einvoiceSupplier"
      :company-id="einvoiceCompanyId"
      :has-document-deposit="einvoiceDocumentDeposit > 0"
      @complete="onItemMappingComplete"
      @cancel="onItemMappingCancel"
      @error="onItemMappingError"
      @location-changed="onMappingLocationChanged"
    />
  </div>
</template>
<script>
import { df, functions } from '@/plugins/firebase'
import { collection, query, where, getDocs, getDoc, doc, limit, onSnapshot } from 'firebase/firestore'
import state from '@/state'
import { Primka } from '@/modules/point-of-sale/components/warehouse/warehouse-module/models/Primka.js'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/hr.js'
import EventBus from '@/plugins/event-bus'
import rules from '@/plugins/rules'
import Dokumenti from '@/modules/point-of-sale/components/warehouse/warehouse-module/WarehouseDocumentsOverview'
import { v4 as uuidv4 } from 'uuid'
import { callAssociates } from '@/api/associates'
import trigram from '@/mixins/trigram'
import { debounce } from 'lodash'
import { eracunApi } from '@/api/eracun'
import UblXmlParser from '@/utils/xmlParser'
import ItemMappingDialog from './dialogs/ItemMappingDialog.vue'
import AddAssociate from '@/modules/company/components/AddAssociate'
import { normalizeOib, findSuppliersByOib } from './einvoice/oib'
import { findPrimkeByInvoiceNumber } from './einvoice/duplicates'
import { compareTotals } from './einvoice/totals'
import { documentDepositTotal, otherDocumentCharges } from './einvoice/lines'
import { saveLearnedCode } from './einvoice/itemUpdate'

export default {
  components: {
    DatePicker,
    Dokumenti,
    ItemMappingDialog,
    AddAssociate
  },
  modules: { Dokumenti },
  mixins: [trigram],
  inject: ['showMsgBox', 'confirm', 'confirmClose'],
  props: {
    modal: Boolean,
    kalkulacija: {
      type: Object,
      default: null
    },
    tipDokumenta: {
      type: String,
      default: 'kalkulacija'
    },
    akcija: {
      type: String,
      default: 'add'
    }
  },
  beforeRouteLeave (to, from, next) {
    // Check if there are unsaved items
    if (this.items && this.items.length > 0) {
      this.confirm({
        title: 'Nespremljeni podaci',
        message: 'Imate nespremlјene artikle. Jeste li sigurni da želite napustiti stranicu? Svi podaci će biti izgubljeni.',
        options: {
          toolbar: true,
          width: 500,
          confirmText: 'Napusti stranicu',
          cancelText: 'Ostani'
        }
      }).then((confirmed) => {
        this.confirmClose()
        if (confirmed) {
          next() // Allow navigation
        } else {
          next(false) // Cancel navigation
        }
      })
    } else {
      next() // No unsaved data, allow navigation
    }
  },
  data: function () {
    return {
      currentAkcija: this.akcija, // Local copy of akcija prop to avoid mutation warning
      absolute: true,
      opacity: 0.46,
      overlay: true,
      loading: false,
      margin: '0px',
      rules: {
        req: rules.req(),
        positive: (v) => v > 0 || 'Mora biti veće od 0'
      },
      // Info modals
      showRabatInfoModal: false,
      showPorezInfoModal: false,
      locations: [],
      selectedLocation: undefined,
      warehouses: [],
      selectedWarehouse: undefined,
      invoiceDate: Date.now(),
      brojPrimke: undefined,
      interniBrojPrimke: undefined,
      brojTemelja: undefined, // Staro "Broj primke" - sada "Broj temelja"
      dobavljaci: [],
      selectedDobavljac: undefined,
      dobavljacSearchInput: null,
      loadingDobavljac: false,
      selectedNAcinPlacanja: undefined,
      nacinplacanja: [
        { name: 'Virman', value: 'Virman' },
        { name: 'Gotovina', value: 'Gotovina' },
        { name: 'Ostalo', value: 'Ostalo' }
      ],
      rabatCalcType: 1,
      rabatCalcTypes: [
        {
          name: 'S jediničnom cijenom',
          value: 1
        },
        {
          name: 'S ukupnom cijenom',
          value: 2
        }
      ],
      porezCalcType: 1,
      porezCalcTypes: [
        {
          name: 'Po artiklima',
          value: 1
        },
        {
          name: 'Po ukupnoj cijeni',
          value: 2
        }
      ],
      // Trigram search properties
      searchQuery: '',
      searchResults: [],
      selectedResultIndex: 0,
      searchDebounce: null,
      searchLoading: false,
      showNoResults: false,
      showFinancialSummaryModal: false,
      // Items management
      items: [],
      itemModal: false,
      currentItem: {},
      editingIndex: null,
      pdvRates: [0, 5, 13, 25],
      // Items table navigation
      selectedItemIndex: -1,
      // Manual input mode
      manualInputMode: false,
      // Manual totals mode
      manualTotalsMode: false,
      manualTotalBezPdv: null,
      manualTotalPdv: null,
      manualTotalSPdv: null,
      // Loaded kalkulacija data
      loadedKalkulacija: null,
      // eInvoice integration
      fromEinvoice: false,
      einvoiceDocumentId: null,
      einvoiceData: null,
      einvoicePendingLearn: [],
      einvoiceDepositLines: [],
      skipNextRabatRecalc: false,
      showItemMappingDialog: false,
      // Warehouse listener
      warehouseUnsubscribe: null
    }
  },
  computed: {
    totalBezPdv () {
      if (this.manualTotalsMode && this.manualTotalBezPdv !== null) {
        return parseFloat(this.manualTotalBezPdv) || 0
      }
      return this.items.reduce((sum, item) => sum + (item.ukupnaCijenaBezPdv || 0), 0)
    },
    totalPdv () {
      if (this.manualTotalsMode && this.manualTotalPdv !== null) {
        return parseFloat(this.manualTotalPdv) || 0
      }
      return this.items.reduce((sum, item) => sum + (item.iznosPdv || 0), 0)
    },
    einvoiceDocumentDeposit () {
      return documentDepositTotal(this.einvoiceData && this.einvoiceData.header.documentCharges)
    },
    einvoiceSupplier () {
      const supplier = this.selectedDobavljac
      if (!supplier || !supplier.value || supplier.value === 'add-new') return null
      return { id: supplier.value, name: supplier.name }
    },
    einvoiceCompanyId () {
      return state.getCurrentCompany().id
    },
    totalSPdv () {
      if (this.manualTotalsMode && this.manualTotalSPdv !== null) {
        return parseFloat(this.manualTotalSPdv) || 0
      }
      return this.items.reduce((sum, item) => sum + (item.ukupnaCijenaSPdv || 0), 0)
    },
    title () {
      return this.currentAkcija === 'update' ? 'Editiranje kalkulacije' : 'Kalkulacija'
    },
    financialSummary () {
      if (!this.items || this.items.length === 0) {
        return {
          totalBeforeDiscountNoPdv: 0,
          totalBeforeDiscountWithPdv: 0,
          discountsByRate: {},
          totalDiscount: 0,
          pdvByRate: {},
          totalBase: 0,
          totalPdv: 0,
          grandTotal: 0
        }
      }

      // Calculate totals before discount
      let totalBeforeDiscountNoPdv = 0
      let totalBeforeDiscountWithPdv = 0
      const discountsByRate = {}
      const pdvByRate = {}

      this.items.forEach(item => {
        const kolicina = parseFloat(item.kolicina) || 0
        const cijenaBezPdv = parseFloat(item.jedinicnaCijenaBezPdv) || 0
        const rabat = parseFloat(item.rabat) || 0
        const stopaPdv = parseFloat(item.stopaPdv) || 0

        // Calculate value before discount
        const ukupnoBezRabataBezPdv = Math.round((cijenaBezPdv * kolicina) * 100) / 100
        const ukupnoBezRabataSPdv = Math.round((ukupnoBezRabataBezPdv * (1 + stopaPdv / 100)) * 100) / 100

        totalBeforeDiscountNoPdv += ukupnoBezRabataBezPdv
        totalBeforeDiscountWithPdv += ukupnoBezRabataSPdv

        // Calculate discount amount for this item
        if (rabat > 0) {
          let discountAmount = 0

          switch (this.rabatCalcType) {
            case 1: {
              // S JEDINIČNOM CIJENOM
              const cijenaSDiskontom = Math.round((cijenaBezPdv * (1 - rabat / 100)) * 100) / 100
              const ukupnoBezPdv = Math.round((kolicina * cijenaSDiskontom) * 100) / 100
              discountAmount = ukupnoBezRabataBezPdv - ukupnoBezPdv
              break
            }
            case 2: {
              // S UKUPNOM CIJENOM
              const ukupnoPrijeRabata = Math.round((cijenaBezPdv * kolicina) * 100) / 100
              const ukupnoBezPdv = Math.round((ukupnoPrijeRabata * (1 - rabat / 100)) * 100) / 100
              discountAmount = ukupnoPrijeRabata - ukupnoBezPdv
              break
            }
          }

          // Group by discount rate
          if (!discountsByRate[rabat]) {
            discountsByRate[rabat] = 0
          }
          discountsByRate[rabat] += discountAmount
        }

        // Group PDV by rate
        if (!pdvByRate[stopaPdv]) {
          pdvByRate[stopaPdv] = { base: 0, amount: 0 }
        }
        pdvByRate[stopaPdv].base += parseFloat(item.ukupnaCijenaBezPdv) || 0
        pdvByRate[stopaPdv].amount += parseFloat(item.iznosPdv) || 0
      })

      // Calculate total discount
      const totalDiscount = Object.values(discountsByRate).reduce((sum, val) => sum + val, 0)

      // Calculate totals
      const totalBase = Object.values(pdvByRate).reduce((sum, data) => sum + data.base, 0)
      const totalPdv = Object.values(pdvByRate).reduce((sum, data) => sum + data.amount, 0)
      const grandTotal = totalBase + totalPdv

      return {
        totalBeforeDiscountNoPdv: Math.round(totalBeforeDiscountNoPdv * 100) / 100,
        totalBeforeDiscountWithPdv: Math.round(totalBeforeDiscountWithPdv * 100) / 100,
        discountsByRate,
        totalDiscount: Math.round(totalDiscount * 100) / 100,
        pdvByRate,
        totalBase: Math.round(totalBase * 100) / 100,
        totalPdv: Math.round(totalPdv * 100) / 100,
        grandTotal: Math.round(grandTotal * 100) / 100
      }
    },
    hasPovratnaNaknada () {
      return this.currentItem &&
             this.currentItem.item &&
             this.currentItem.item.naknade &&
             this.currentItem.item.naknade.povratna
    },
    povratnaNaknadaAmountPerUnit () {
      if (!this.hasPovratnaNaknada) return 0
      return (this.currentItem.item.naknade.povratna.amount || 0) / 100
    },
    // Marža iznos
    marginAmount () {
      if (!this.currentItem ||
          this.currentItem.retailPriceWithoutPdv === null ||
          !this.currentItem.jedinicnaCijenaBezPdv) {
        return null
      }

      const cijenaBezPdv = parseFloat(this.currentItem.jedinicnaCijenaBezPdv) || 0
      const rabat = parseFloat(this.currentItem.rabat) || 0
      const prodajnaCijena = parseFloat(this.currentItem.retailPriceWithoutPdv) || 0

      // Izračunaj cijenu s rabatom direktno ovdje
      let nabavnaCijena = cijenaBezPdv
      if (rabat > 0) {
        nabavnaCijena = cijenaBezPdv * (1 - rabat / 100)
      }

      return Math.round((prodajnaCijena - nabavnaCijena) * 100) / 100
    },
    // Marža postotak
    marginPercentage () {
      if (!this.currentItem ||
          this.currentItem.retailPriceWithoutPdv === null ||
          !this.currentItem.jedinicnaCijenaBezPdv ||
          this.marginAmount === null) {
        return null
      }

      const cijenaBezPdv = parseFloat(this.currentItem.jedinicnaCijenaBezPdv) || 0
      const rabat = parseFloat(this.currentItem.rabat) || 0

      // Izračunaj cijenu s rabatom direktno ovdje
      let nabavnaCijena = cijenaBezPdv
      if (rabat > 0) {
        nabavnaCijena = cijenaBezPdv * (1 - rabat / 100)
      }

      if (nabavnaCijena === 0) {
        return null
      }

      return Math.round((this.marginAmount / nabavnaCijena) * 10000) / 100
    },
    povratnaNaknadaCalculation () {
      if (!this.items || this.items.length === 0) {
        return {
          hasPN: false,
          totalQuantity: 0,
          totalAmount: 0,
          items: []
        }
      }

      let totalQuantity = 0
      let totalAmount = 0
      const pnItems = []

      this.items.forEach(item => {
        // Provjeri ima li artikl povratnu naknadu
        if (item.item && item.item.naknade && item.item.naknade.povratna && item.povratnaNaknadaIznos) {
          const pn = item.item.naknade.povratna
          const quantity = parseFloat(item.kolicina) || 0
          // Koristi već izračunati/uneseni iznos iz itema
          const subtotal = parseFloat(item.povratnaNaknadaIznos) || 0
          const amountPerUnit = quantity > 0 ? subtotal / quantity : (pn.amount / 100)

          totalQuantity += quantity
          totalAmount += subtotal

          pnItems.push({
            artikl: item.artikl,
            quantity: quantity,
            amountPerUnit: amountPerUnit,
            subtotal: subtotal,
            taxRate: pn.taxes && pn.taxes.length > 0 ? pn.taxes[0].rate : 0
          })
        }
      })

      return {
        hasPN: pnItems.length > 0,
        totalQuantity: Math.round(totalQuantity * 100) / 100,
        totalAmount: Math.round(totalAmount * 100) / 100,
        items: pnItems
      }
    },
    dobavljaciWithAddOption () {
      // Uvijek dodaj opciju "Dodaj novog dobavljača" na dno liste kada je pretraga aktivna (3+ znakova)
      const shouldShowAddOption = this.dobavljacSearchInput &&
                                    this.dobavljacSearchInput.trim().length >= 3 &&
                                    !this.loadingDobavljac

      if (shouldShowAddOption) {
        // Dodaj sve pronađene dobavljače + opciju za dodavanje na dno
        return [
          ...this.dobavljaci,
          {
            name: 'Dodaj novog dobavljača',
            value: 'add-new'
          }
        ]
      }

      // Ako nema pretrage, prikaži samo pronađene dobavljače
      return this.dobavljaci
    }
  },
  methods: {
    // eInvoice integration methods
    async loadFromEinvoice () {
      try {
        this.loading = true

        // Fetch XML
        const companyId = state.getCurrentCompany().id
        const xmlResponse = await eracunApi.getDocumentXml(this.einvoiceDocumentId, companyId)

        // Parse XML
        const xmlString = xmlResponse.document || xmlResponse
        const parser = new UblXmlParser(xmlString)
        const header = parser.parseInvoiceHeader()
        const lines = parser.parseInvoiceLines()

        this.einvoiceData = { header, lines }

        // Pre-fill header fields
        await this.prefillHeaderFromEinvoice(header)

        // Open item mapping dialog - user will select location/warehouse inside
        this.showItemMappingDialog = true
      } catch (error) {
        console.error('Error loading eInvoice:', error)
        const errorMsg = error.parsedMessage || error.message || 'Nepoznata greška'
        this.showMsgBox({
          text: `Greška pri učitavanju e-računa: ${errorMsg}`,
          color: 'error'
        })
      } finally {
        this.loading = false
      }
    },

    async prefillHeaderFromEinvoice (header) {
      // Set invoice date
      const issued = /^(\d{4})-(\d{2})-(\d{2})/.exec(header.issueDate || '')
      if (issued) {
        const timestamp = new Date(+issued[1], +issued[2] - 1, +issued[3]).getTime()
        if (Number.isFinite(timestamp)) this.invoiceDate = timestamp
      }

      const virman = (this.nacinplacanja || []).find(np => np.value === 'Virman')
      if (virman) this.selectedNAcinPlacanja = virman

      // Broj temelja = broj računa dobavljača (šalje se kao brojPrimke)
      if (header.invoiceId) {
        this.brojTemelja = header.invoiceId
      }

      // Find and set supplier
      if (header.supplierName || header.supplierOib) {
        await this.findAndSetSupplier(header.supplierOib, header.supplierName)
      }
    },

    async findAndSetSupplier (oib, name) {
      const normalized = normalizeOib(oib)
      if (!normalized) {
        this.showMsgBox({
          text: `Račun ne sadrži OIB dobavljača${name ? ` (${name})` : ''}. Molimo odaberite dobavljača ručno.`,
          color: 'warning'
        })
        return
      }

      try {
        const path = `/associates/${state.getCurrentCompany().id}/associate?filter=trigram(eq:${encodeURIComponent(normalized)})`
        const response = await callAssociates('get', path)
        const found = response && response.status === 200 && response.data && response.data.associates
          ? Object.keys(response.data.associates).map(key => response.data.associates[key])
          : []
        const suppliers = found.filter(a => a.status === 'OK' && a.associate_type && a.associate_type.SUPPLIER)
        const matches = findSuppliersByOib(suppliers, normalized)
          .map(a => ({ name: a.name, value: a.id, all: a }))
          .sort((a, b) => a.name.localeCompare(b.name))

        if (matches.length === 1) {
          this.selectedDobavljac = matches[0]
        } else if (matches.length > 1) {
          this.dobavljaci = matches
          this.showMsgBox({
            text: `Pronađeno je ${matches.length} dobavljača s OIB-om ${normalized}. Molimo odaberite ispravnog ručno.`,
            color: 'warning'
          })
        } else {
          const existing = findSuppliersByOib(found.filter(a => a.status === 'OK'), normalized).map(a => ({ ...a, oibs: [normalized] }))
          this.$refs.addAssociate.open(existing, { name, oib: normalized })
        }
      } catch (error) {
        console.error('Error finding supplier:', error)
        this.showMsgBox({
          text: 'Pretraga dobavljača nije uspjela. Molimo odaberite dobavljača ručno.',
          color: 'warning'
        })
      }
    },

    onItemMappingComplete (data) {
      const mappedItems = data.items || []
      const location = data.location
      const warehouse = data.warehouse

      if (location) {
        this.selectedLocation = location
      }
      if (warehouse) {
        this.selectedWarehouse = warehouse
        // Postavi listener za delivery_counter
        this.$nextTick(() => {
          this.onWarehouseChange()
        })
      }

      // Primka iz e-računa: rabat na ukupnu cijenu; watcher ne smije preračunati iznose iz dijaloga
      if (this.rabatCalcType !== 2) {
        this.skipNextRabatRecalc = true
        this.rabatCalcType = 2
      }

      const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100
      this.items = mappedItems.map(item => {
        const ukupnaCijenaBezPdv = round2(item.ukupnaCijenaBezPdv)
        const iznosPdv = round2(ukupnaCijenaBezPdv * (item.stopaPdv / 100))
        return {
          id: item.id,
          artikl: item.artikl,
          code: item.code,
          kolicina: item.kolicina,
          jedinicnaCijenaBezPdv: item.jedinicnaCijenaBezPdv,
          jedinicnaCijenaSPdv: item.jedinicnaCijenaSPdv,
          jedinicnaCijenaSRabatom: item.jedinicnaCijenaSRabatom,
          stopaPdv: item.stopaPdv,
          rabat: item.rabat || 0,
          povratnaNaknadaIznos: item.povratnaNaknadaIznos || 0,
          mjernaJedinica: item.mjernaJedinica,
          mjernaJedinicaNaziv: item.mjernaJedinicaNaziv || item.mjernaJedinica,
          item: item.item,
          stock: item.stock || 0,
          lastPrice: item.lastPrice || 0,
          ukupnaCijenaBezPdv,
          iznosPdv,
          ukupnaCijenaSPdv: round2(ukupnaCijenaBezPdv + iznosPdv),
          xmlSourceName: item.xmlSourceName
        }
      })

      this.einvoicePendingLearn = mappedItems
        .filter(item => item.mappedManually && !item.wasAmbiguous && item.sellersItemId && String(item.sellersItemId).trim())
        .map(item => ({ itemId: item.id, code: String(item.sellersItemId).trim() }))
      this.einvoiceDepositLines = data.depositLines || []

      // Close dialog
      this.showItemMappingDialog = false
    },

    onItemMappingCancel () {
      this.confirm({
        title: 'Odustani od mapiranja',
        message: 'Jeste li sigurni da želite odustati? Svi mapirani artikli će biti izgubljeni.',
        options: {
          toolbar: true,
          width: 500,
          confirmText: 'Da, odustani',
          cancelText: 'Nastavi s mapiranjem'
        }
      }).then((confirmed) => {
        this.confirmClose()
        if (!confirmed) return
        this.showItemMappingDialog = false
        this.$router.push({
          name: 'company.incoming-einvoices',
          params: {
            companyId: state.getCurrentCompany().id
          }
        })
      })
    },

    // Prije spremanja: false = korisnik je odustao jer je račun već preuzet
    async confirmEinvoiceDuplicate () {
      if (!this.einvoiceDocumentId || !this.selectedWarehouse) return true
      const warehouseIds = (this.warehouses || []).map(warehouse => warehouse.id)
      if (!warehouseIds.length) warehouseIds.push(this.selectedWarehouse.id)
      const supplierName = this.selectedDobavljac && this.selectedDobavljac.name
      let existing = []
      try {
        existing = await findPrimkeByInvoiceNumber(df, { warehouseIds, invoiceNumber: this.brojTemelja, supplierName })
      } catch (error) {
        console.error('Error checking duplicate e-invoice primka:', error)
        return true
      }
      if (!existing.length) return true
      const confirmed = await this.confirm({
        title: 'Račun je već preuzet',
        message: `Primka za račun ${this.brojTemelja} dobavljača ${supplierName} već postoji (${existing.length}). Želite li svejedno spremiti novu primku?`,
        options: {
          toolbar: true,
          width: 500,
          confirmText: 'Spremi svejedno',
          cancelText: 'Odustani'
        }
      })
      this.confirmClose()
      return !!confirmed
    },

    // Informativno upozorenje (ne blokira spremanje); null kad se iznosi podudaraju
    einvoiceTotalsWarning () {
      if (!this.einvoiceDocumentId || !this.einvoiceData) return null
      const invoiceTotal = this.einvoiceData.header.taxInclusiveAmount
      if (typeof invoiceTotal !== 'number' || !Number.isFinite(invoiceTotal)) return null
      const depositTotal = this.povratnaNaknadaCalculation.hasPN ? this.povratnaNaknadaCalculation.totalAmount : 0
      const { matches, diff } = compareTotals({ invoiceTotal, primkaTotal: this.totalSPdv, depositTotal })
      if (matches) return null
      const invoiceDeposit = this.einvoiceDocumentDeposit +
        this.einvoiceDepositLines.reduce((sum, line) => sum + (parseFloat(line.lineTotal) || 0), 0)
      const depositNote = Math.abs(invoiceDeposit - depositTotal) > 0.01
        ? ` Povratna naknada na računu (${invoiceDeposit.toFixed(2)} €) razlikuje se od one u kalkulaciji (${depositTotal.toFixed(2)} €).`
        : ''
      const others = otherDocumentCharges(this.einvoiceData.header.documentCharges)
      const othersNote = others.length
        ? ` Troškovi i popusti na razini računa nisu preneseni: ${others.map(c => `${c.reason || 'bez naziva'} ${c.charge ? '' : '-'}${c.amount.toFixed(2)} €`).join(', ')}.`
        : ''
      return `Ukupni iznos primke (${(this.totalSPdv + depositTotal).toFixed(2)} €) razlikuje se od iznosa računa (${invoiceTotal.toFixed(2)} €) za ${diff.toFixed(2)} €.${depositNote}${othersNote}`
    },

    async learnEinvoiceCodes (pending, associate) {
      if (!pending.length || !associate) return
      const companyId = state.getCurrentCompany().id
      const callItemApi = (payload) => functions.httpsCallable('companyitemapi')(payload)
      const readItem = async (itemId) => {
        const snapshot = await getDoc(doc(df, `companies/${companyId}/items/${itemId}`))
        return snapshot.exists() ? snapshot.data() : null
      }
      const failed = []
      for (const entry of pending) {
        const result = await saveLearnedCode({ callItemApi, readItem, companyId, itemId: entry.itemId, associate, code: entry.code })
        if (!result.ok) {
          console.error('Learning supplier code failed:', entry.itemId, result.error)
          failed.push(entry)
        }
      }
      if (!failed.length) return
      const retry = await this.confirm({
        title: 'Šifre dobavljača nisu spremljene',
        message: `Primka je spremljena, ali šifra dobavljača nije zapamćena za ${failed.length} artikala. Pokušati ponovno?`,
        options: {
          toolbar: true,
          width: 500,
          confirmText: 'Pokušaj ponovno',
          cancelText: 'Zatvori'
        }
      })
      this.confirmClose()
      if (retry) await this.learnEinvoiceCodes(failed, associate)
    },

    clearEinvoiceState () {
      this.einvoicePendingLearn = []
      this.einvoiceDepositLines = []
      this.einvoiceData = null
      this.einvoiceDocumentId = null
    },

    onItemMappingError (message) {
      // Handle error from ItemMappingDialog
      this.showMsgBox({
        text: message,
        color: 'error'
      })
    },

    async onMappingLocationChanged (location) {
      // When location changes in mapping dialog, fetch warehouses for that location
      if (location && location.id) {
        this.selectedLocation = location
        await this.getWarehouses()
      }
    },

    disableFutureDates (date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date > today
    },
    toggleManualTotalsMode (value) {
      // v-model već postavlja manualTotalsMode, ne treba ponovno toggleovati
      if (value) {
        // Initialize manual values with current displayed totals (from db or calculated)
        this.manualTotalBezPdv = Math.round(this.totalBezPdv * 100) / 100
        this.manualTotalPdv = Math.round(this.totalPdv * 100) / 100
        this.manualTotalSPdv = Math.round(this.totalSPdv * 100) / 100
      } else {
        // Reset manual values
        this.manualTotalBezPdv = null
        this.manualTotalPdv = null
        this.manualTotalSPdv = null
      }
    },
    recalculate () {
      if (!this.tabulator) {
        return
      }

      this.tabulator.redraw(true)
    },
    isDisableRabatChange () {
      if (!this.tabulator) {
        return false
      }

      if (this.tabulator.getData().length > 0) {
        return true
      }
    },
    customHeaderFilterFunc (headerValue, rowValue, rowData, filterParams) {
      if (headerValue === null) return true
      return headerValue === rowValue
    },
    handleCheckboxChange (columnId, checked) {
      const otherColumnId =
        columnId === 'jedinicnaCijenaSPdv'
          ? 'jedinicnaCijenaBezPdv'
          : 'jedinicnaCijenaSPdv'
      // const otherCheckbox = this.checkboxes[otherColumnId]
      if (checked) {
        // otherCheckbox.checked = false
        // otherCheckbox.indeterminate = false

        // Enable editing for the current column and disable for the other
        this.tabulator.getColumn(columnId).updateDefinition({ editor: true })
        this.tabulator
          .getColumn(otherColumnId)
          .updateDefinition({ editor: false })

        // Update selectedColumn variable
        this.selectedColumn = columnId
      } else {
        // this.checkboxes[columnId].indeterminate = true

        // Reset editable status
        this.tabulator.getColumn(columnId).updateDefinition({ editor: false })
        this.tabulator
          .getColumn(otherColumnId)
          .updateDefinition({ editor: true })
      }

      // Update the checkbox states
      this.updateCheckboxStates(columnId, checked)

      this.tabulator.getColumn('rabat').updateDefinition({ editor: true })
      this.tabulator
        .getColumn('jedinicnaCijenaSRabatom')
        .updateDefinition({ editor: true })
    },
    updateCheckboxStates (columnId, checked) {
      // Update the current checkbox state
      this.checkboxes[columnId].checked = checked
      this.checkboxes[columnId].indeterminate = false

      // Update the other checkbox state
      const otherColumnId =
        columnId === 'jedinicnaCijenaSPdv'
          ? 'jedinicnaCijenaBezPdv'
          : 'jedinicnaCijenaSPdv'
      this.checkboxes[otherColumnId].checked = !checked
      this.checkboxes[otherColumnId].indeterminate = false
    },
    customCheckboxHeaderFilter (
      cell,
      onRendered,
      success,
      cancel,
      editorParams
    ) {
      const columnId = editorParams.columnId
      const checkbox = document.createElement('input')
      checkbox.type = 'checkbox'
      checkbox.indeterminate = true // Start with indeterminate state

      checkbox.addEventListener('change', () => {
        // success(checkbox.checked)
        this.handleCheckboxChange(columnId, checkbox.checked)
      })

      // Save reference to checkbox
      if (!this.checkboxes) {
        this.checkboxes = {}
      }
      this.checkboxes[columnId] = checkbox

      return checkbox
    },

    closeModal () {
      this.$emit('closeModal')
    },
    cancelAndGoBack () {
      // Check if there are unsaved items (same logic as beforeRouteLeave)
      if (this.items && this.items.length > 0) {
        this.confirm({
          title: 'Nespremljeni podaci',
          message: 'Imate nespremlјene artikle. Jeste li sigurni da želite napustiti stranicu? Svi podaci će biti izgubljeni.',
          options: {
            toolbar: true,
            width: 500,
            confirmText: 'Napusti stranicu',
            cancelText: 'Ostani'
          }
        }).then((confirmed) => {
          this.confirmClose()
          if (confirmed) {
            this.leaveCalculation()
          }
          // If not confirmed, do nothing (stay on page)
        })
      } else {
        this.leaveCalculation()
      }
    },
    leaveCalculation () {
      if (this.fromEinvoice) {
        this.$router.push({
          name: 'company.incoming-einvoices',
          params: { companyId: state.getCurrentCompany().id }
        })
      } else {
        this.$router.back()
      }
    },
    calculateHeights () {
      this.tabulator.setHeight(window.innerHeight - 185)
    },
    async presubmit () {
      if (!this.$refs.primkaForm.validate()) return

      // Validate items
      if (this.items.length === 0) {
        this.showMsgBox({
          text: 'Dodajte barem jedan artikl',
          color: 'error',
          actions: ['cancel'],
          cancelBtnText: 'OK'
        })
        return
      }

      if (!(await this.confirmEinvoiceDuplicate())) return
      const totalsWarning = this.einvoiceTotalsWarning()

      this.confirm({
        title: 'Kalkulacija',
        message: 'Jeste li sigurni da želite spremiti trenutne podatke?' + (totalsWarning ? ` ${totalsWarning}` : ''),
        options: {
          toolbar: true,
          width: 410,
          confirmText: 'Spremi',
          cancelText: 'Odustani'
        }
      }).then(async (resp) => {
        this.confirmClose()
        if (resp) {
          this.submit()
        }
      })
    },
    submit () {
      this.loading = true

      const primka = new Primka()

      // Add items to Primka
      // NOTE: Do NOT multiply values here - Artikl class setters will do that automatically
      this.items.forEach((item) => {
        const artikl = {
          id: item.id,
          artikl: item.artikl,
          kolicina: item.kolicina, // Artikl.setKolicina will multiply by 1000
          mjernaJedinica: item.mjernaJedinica,
          jedinicnaCijenaBezPdv: item.jedinicnaCijenaBezPdv, // Artikl setter will multiply by 100000
          jedinicnaCijenaSPdv: item.jedinicnaCijenaSPdv, // Artikl setter will multiply by 100
          jedinicnaCijenaSRabatom: item.jedinicnaCijenaSRabatom, // Artikl setter will multiply by 100
          rabat: item.rabat, // Artikl setter will multiply by 100
          stopaPdv: item.stopaPdv, // Artikl setter will multiply by 100
          ukupnaCijenaBezPdv: item.ukupnaCijenaBezPdv, // Artikl setter will multiply by 10000
          iznosPdv: item.iznosPdv, // Artikl setter will multiply by 100
          ukupnaCijenaSPdv: item.ukupnaCijenaSPdv, // Artikl setter will multiply by 100
          item: item.item
        }
        primka.setArtikl(artikl)
      })

      // Dodaj povratnu naknadu kao poseban artikl ako postoji
      if (this.povratnaNaknadaCalculation.hasPN) {
        const pnCalc = this.povratnaNaknadaCalculation

        // Uzmi poreznu stopu prvog artikla (sve bi trebale biti iste, tipično 0%)
        const taxRate = pnCalc.items.length > 0 ? pnCalc.items[0].taxRate : 0

        // Izračunaj cijene na temelju porezne stope
        const ukupnaCijenaSPdv = pnCalc.totalAmount
        const ukupnaCijenaBezPdv = taxRate > 0
          ? Math.round((ukupnaCijenaSPdv / (1 + taxRate / 100)) * 100) / 100
          : ukupnaCijenaSPdv
        const jedinicnaCijenaBezPdv = pnCalc.totalQuantity > 0
          ? Math.round((ukupnaCijenaBezPdv / pnCalc.totalQuantity) * 100) / 100
          : 0

        const pnArtikl = {
          id: '-1',
          artikl: 'Povratna naknada',
          kolicina: pnCalc.totalQuantity,
          mjernaJedinica: 'kom',
          jedinicnaCijenaBezPdv: jedinicnaCijenaBezPdv,
          jedinicnaCijenaSPdv: ukupnaCijenaSPdv / pnCalc.totalQuantity,
          jedinicnaCijenaSRabatom: jedinicnaCijenaBezPdv,
          rabat: 0,
          stopaPdv: taxRate,
          ukupnaCijenaBezPdv: ukupnaCijenaBezPdv,
          iznosPdv: Math.round((ukupnaCijenaSPdv - ukupnaCijenaBezPdv) * 100) / 100,
          ukupnaCijenaSPdv: ukupnaCijenaSPdv,
          item: {
            id: '-1',
            name: 'Povratna naknada',
            storage_unit: 'kom'
          }
        }

        primka.setArtikl(pnArtikl)
      }

      primka.setUkupnoPovratnaNaknada()

      primka.setIdFirme(state.getCurrentCompany().id)
      primka.setIdSkladista(this.selectedWarehouse.id)
      primka.setNazivSkladista(this.selectedWarehouse.name)
      primka.setDatum(this.invoiceDate)
      primka.setBrojPrimke(this.brojTemelja) // Broj temelja
      primka.setInterniBrojPrimke(this.interniBrojPrimke) // Interni broj primke
      primka.setDobavljac(this.selectedDobavljac.name)
      primka.setNacinPlacanja(this.selectedNAcinPlacanja.value)
      // NOTE: Do NOT multiply - setters will multiply by 100 automatically
      primka.setUkupanIznosBezPdv(this.totalBezPdv)
      primka.setUkupanIznosSPdv(this.totalSPdv)
      primka.setUkupanIznosPdv(this.totalPdv)
      primka.setIdLokacije(this.selectedWarehouse.location_id)
      primka.setProdajnoSkladiste(this.selectedWarehouse.selling_warehouse)
      // PROMJENA: Koristi akcija prop umjesto hardcoded 'add'
      primka.setAkcija(this.currentAkcija)
      primka.setTipDokumenta('kalkulacija')
      primka.setTipRabata(this.rabatCalcType)
      primka.setTipPoreza(this.porezCalcType)
      delete primka.povezanaPrimka

      const itemIds = new Set(this.items.map(item => item.id))
      const learnPending = this.einvoicePendingLearn.filter(entry => itemIds.has(entry.itemId))
      const learnSupplier = this.einvoiceSupplier

      var newdeliveryNote = functions.httpsCallable('newdeliverynote')

      // PROMJENA: Proslijedi document ID kada se ažurira
      const resourceID = this.currentAkcija === 'update' ? (this.kalkulacija?.id || this.$route.query.id) : ''

      newdeliveryNote({
        action: {
          operation: 'set',
          entity: 'nova_primka',
          resource_id: resourceID,
          params: primka
        }
      }).then(async (result) => {
        if (result.data.code === 200) {
          this.loading = false
          this.showMsgBox({
            // PROMJENA: Dinamička poruka ovisno o akciji
            text: this.currentAkcija === 'update'
              ? 'Kalkulacija uspješno ažurirana.'
              : 'Kalkulacija uspješno spremljena.',
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'info'
          })
          this.clearEinvoiceState()
          this.learnEinvoiceCodes(learnPending, learnSupplier)
          this.items = []
          this.brojPrimke = undefined
          this.interniBrojPrimke = undefined
          // Reset manual totals mode
          this.manualTotalsMode = false
          this.manualTotalBezPdv = null
          this.manualTotalPdv = null
          this.manualTotalSPdv = null
          // Reset forme nakon uspješnog spremanja (samo za 'add', ne za 'update')
          if (this.currentAkcija !== 'update') {
            // Listener će automatski ažurirati delivery_counter iz baze
            this.resetForm()
          } else {
            // Za update akciju, isprazni items da beforeRouteLeave ne blokira navigaciju
            this.items = []
          }
          if (this.modal) {
            this.closeModal()
          } else if (this.currentAkcija === 'update') {
            // Navigate back to warehouse documents overview after successful update
            this.$router.back()
          }
        } else {
          this.loading = false
          this.showMsgBox({
            // PROMJENA: Dinamička poruka ovisno o akciji
            text: this.currentAkcija === 'update'
              ? 'Nije uspjelo ažuriranje kalkulacije.'
              : 'Nije uspjelo spremanje kalkulacije.',
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'error'
          })
        }
      }, (error) => {
        console.error('Error saving kalkulacija:', error)
        this.loading = false
        this.showMsgBox({
          text: this.currentAkcija === 'update'
            ? 'Nije uspjelo ažuriranje kalkulacije.'
            : 'Nije uspjelo spremanje kalkulacije.',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })
      }).catch((error) => {
        console.error('Error after saving kalkulacija:', error)
      })
    },
    showDoc () {
      this.$modal.show('primke')
    },
    clearData () {
      this.confirm({
        title: 'Brisanje podataka',
        message: 'Jeste li sigurni da želite obrisati upisane podatke?',
        options: {
          toolbar: true,
          width: 410,
          confirmText: 'Obriši',
          cancelText: 'Odustani'
        }
      }).then(async (resp) => {
        this.confirmClose()
        if (resp) {
          this.items = []
        }
      })
    },
    // Trigram Search Methods
    async performTrigramSearch () {
      clearTimeout(this.searchDebounce)
      this.showNoResults = false // Reset no results message

      if (!this.searchQuery || this.searchQuery.length < 3) {
        this.searchResults = []
        return
      }

      if (!this.selectedWarehouse || !this.selectedWarehouse.id) {
        this.searchResults = []
        return
      }

      this.searchDebounce = setTimeout(async () => {
        this.searchLoading = true

        try {
          const triGramObject = this.triGram(this.searchQuery.toLowerCase())

          const searchConstraints = []

          Object.keys(triGramObject).forEach(name =>
            searchConstraints.push(where(`item.meta.${name}`, '==', true))
          )

          searchConstraints.push(where('item.type', '==', 'GOODS'))
          searchConstraints.push(limit(50))

          const path = `warehouses/${this.selectedWarehouse.id}/extended_items`

          const constraints = [collection(df, path), ...searchConstraints]
          const q = query.apply(this, constraints)

          const snapshot = await getDocs(q)

          this.searchResults = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            // Skip items with normativ - show only sirovine
            if (data.item && data.item.norm !== undefined && data.item.norm !== null) {
              return
            }
            this.searchResults.push(data)
          })

          this.searchResults.sort((a, b) =>
            a.item.name.localeCompare(b.item.name)
          )
          this.selectedResultIndex = 0

          // Show "no results" message only after search completes and if truly empty
          // Add 500ms delay to avoid flashing message
          if (this.searchResults.length === 0) {
            setTimeout(() => {
              // Check again to make sure query didn't change
              if (this.searchQuery && this.searchQuery.length >= 3 && this.searchResults.length === 0 && !this.searchLoading) {
                this.showNoResults = true
              }
            }, 500)
          }
        } catch (error) {
          console.error('Search error:', error)
          this.showMsgBox({
            text: 'Greška pri pretrazi artikala',
            color: 'error',
            actions: ['cancel'],
            cancelBtnText: 'OK'
          })
        } finally {
          this.searchLoading = false
        }
      }, 300)
    },
    async openModalForItem (searchItem) {
      if (!searchItem || !searchItem.item) return

      let item = searchItem.item

      // Fetch full item data from items collection to get warehouse_units
      try {
        const itemDocRef = doc(df, `companies/${state.getCurrentCompany().id}/items/${item.id}`)
        const itemDoc = await getDoc(itemDocRef)

        if (itemDoc.exists()) {
          const fullItemData = itemDoc.data()

          // Merge warehouse_units from full item data
          if (fullItemData.warehouse_units) {
            item = { ...item, warehouse_units: fullItemData.warehouse_units }
          }
        }
      } catch (error) {
        console.error('Error fetching item data:', error)
        this.showMsgBox({
          text: 'Greška pri učitavanju podataka artikla',
          color: 'error',
          actions: ['cancel'],
          cancelBtnText: 'OK'
        })
        return
      }

      let mjernaJedinicaId = ''
      let stopaPdv = 0
      const availableUnits = []

      // Get available units from warehouse_units
      if (item.warehouse_units?.units) {
        // Use Object.keys to get unit IDs (keys), then access the unit object
        Object.keys(item.warehouse_units.units).forEach(unitKey => {
          const unit = item.warehouse_units.units[unitKey]
          availableUnits.push({
            id: unitKey, // Unit ID is the key in the warehouse_units.units object
            name: unit.storage_unit, // Use storage_unit as display name
            storage_amount: unit.storage_amount,
            base_unit: unit.base_unit || false,
            default_store: unit.default_store || false
          })
        })

        // Find default_store unit
        const defaultStoreUnit = availableUnits.find(u => u.default_store === true)
        if (defaultStoreUnit) {
          mjernaJedinicaId = defaultStoreUnit.id
        } else {
          // Fallback to first unit
          mjernaJedinicaId = availableUnits[0]?.id || ''
        }
      } else if (item.storage_unit) {
        // Fallback to storage_unit if no warehouse_units
        availableUnits.push({
          id: item.storage_unit,
          name: item.storage_unit
        })
        mjernaJedinicaId = item.storage_unit
      } else {
        // Last resort fallback
        availableUnits.push({
          id: 'kom',
          name: 'kom'
        })
        mjernaJedinicaId = 'kom'
      }

      // Get PDV rate
      if (item.tax_group_object?.pdv_rate) {
        stopaPdv = item.tax_group_object.pdv_rate
      }

      // Get last purchase price from warehouse_data
      // NOTE: warehouse_data is at same level as item in searchItem object
      let purchasePrice = 0
      if (searchItem.warehouse_data?.quantity_by_purchase_price &&
          Array.isArray(searchItem.warehouse_data.quantity_by_purchase_price) &&
          searchItem.warehouse_data.quantity_by_purchase_price.length > 0) {
        // Get last element (most recent)
        const lastEntry = searchItem.warehouse_data.quantity_by_purchase_price[
          searchItem.warehouse_data.quantity_by_purchase_price.length - 1
        ]
        // purchase_price is stored in cents (e.g., 331 = 3.31 EUR), divide by 100 and round to 2 decimals
        purchasePrice = Math.round((lastEntry.purchase_price || 0)) / 100
      } else {
        // Fallback to last_price if no warehouse_data, round to 2 decimals
        purchasePrice = item.last_price ? Math.round(item.last_price * 100) / 100 : 0
      }

      // Fetch retail price from location_pricelist
      let retailPriceWithoutPdv = null
      let retailPriceWithPdv = null
      let retailPriceCurrency = null
      let retailPriceTaxRate = null
      try {
        if (this.selectedLocation && this.selectedLocation.id && item.id) {
          const pricelistDocRef = doc(df, `location_pricelist/${this.selectedLocation.id}/items/${item.id}`)
          const pricelistDoc = await getDoc(pricelistDocRef)

          if (pricelistDoc.exists()) {
            const pricelistData = pricelistDoc.data()

            // Get first active currency price (usually EUR)
            if (pricelistData.prices) {
              const currencies = Object.keys(pricelistData.prices)
              for (const currency of currencies) {
                const priceInfo = pricelistData.prices[currency]
                if (priceInfo.active && priceInfo.price) {
                  retailPriceCurrency = currency
                  // ISPRAVKA: priceInfo.price je cijena S PDV-om (stored in cents)
                  retailPriceWithPdv = Math.round(priceInfo.price) / 100

                  // Get povratna naknada first
                  let povratnaNaknadaPerUnit = 0
                  if (item.naknade && item.naknade.povratna && item.naknade.povratna.amount) {
                    povratnaNaknadaPerUnit = item.naknade.povratna.amount / 100 // Convert from cents to EUR
                  }

                  // Calculate price WITHOUT PDV if taxes are defined
                  if (priceInfo.taxes && Array.isArray(priceInfo.taxes) && priceInfo.taxes.length > 0) {
                    // ISPRAVKA: taxRate je pohranjen kao 2500 za 25%, trebamo podijeliti sa 100
                    const taxRate = (priceInfo.taxes[0].rate || 0) / 100
                    retailPriceTaxRate = taxRate

                    // NOVO: Prvo oduzmi povratnu naknadu od cijene s PDV-om
                    const priceAfterDeposit = retailPriceWithPdv - povratnaNaknadaPerUnit

                    // Zatim izračunaj osnovicu (cijenu bez PDV-a)
                    retailPriceWithoutPdv = Math.round((priceAfterDeposit / (1 + taxRate / 100)) * 100) / 100
                  } else {
                    retailPriceTaxRate = 0
                    // No tax, just subtract povratna naknada
                    retailPriceWithoutPdv = Math.round((retailPriceWithPdv - povratnaNaknadaPerUnit) * 100) / 100
                  }
                  break // Use first active currency
                }
              }
            }
          }
        }
      } catch (error) {
        console.error('Error fetching retail price:', error)
        // Don't show error to user, just continue without retail price
      }

      // Set current item for modal
      this.currentItem = {
        id: searchItem.id,
        artikl: item.name,
        code: item.code,
        stock: item.stock,
        lastPrice: purchasePrice,
        kolicina: 1,
        mjernaJedinica: mjernaJedinicaId,
        mjernaJedinicaNaziv: availableUnits.find(u => u.id === mjernaJedinicaId)?.name || '',
        availableUnits: availableUnits,
        jedinicnaCijenaBezPdv: purchasePrice,
        jedinicnaCijenaSPdv: 0,
        rabat: 0,
        stopaPdv: stopaPdv,
        ukupnaCijenaBezPdv: 0,
        iznosPdv: 0,
        ukupnaCijenaSPdv: 0,
        item: item,
        manualInput: false, // Track if this item was entered manually
        // Retail prices from location_pricelist
        retailPriceWithoutPdv: retailPriceWithoutPdv,
        retailPriceWithPdv: retailPriceWithPdv,
        retailPriceCurrency: retailPriceCurrency,
        retailPriceTaxRate: retailPriceTaxRate
      }

      this.editingIndex = null
      this.manualInputMode = false // Default to automatic calculation for new items
      this.calculateItemTotals()
      this.itemModal = true

      // Clear search
      this.searchQuery = ''
      this.searchResults = []
      this.selectedResultIndex = 0

      // Focus and select quantity field
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.kolicinaField) {
            const input = this.$refs.kolicinaField.$el.querySelector('input')
            if (input) {
              input.focus()
              input.select()
            }
          }
        }, 150)
      })
    },
    saveItem () {
      // Validate required fields
      if (!this.currentItem.kolicina || this.currentItem.kolicina === 0) {
        this.showMsgBox({
          text: 'Količina ne smije biti 0',
          color: 'error',
          actions: ['cancel'],
          cancelBtnText: 'OK'
        })
        return
      }

      if (!this.currentItem.mjernaJedinica) {
        this.showMsgBox({
          text: 'Odaberite mjernu jedinicu',
          color: 'error',
          actions: ['cancel'],
          cancelBtnText: 'OK'
        })
        return
      }

      // Calculate final totals only if not in manual mode
      if (!this.manualInputMode) {
        this.calculateItemTotals()
      }

      // Create item copy
      const itemToSave = {
        id: this.currentItem.id,
        artikl: this.currentItem.artikl,
        code: this.currentItem.code,
        kolicina: parseFloat(this.currentItem.kolicina),
        mjernaJedinica: this.currentItem.mjernaJedinica,
        mjernaJedinicaNaziv: this.currentItem.mjernaJedinicaNaziv,
        jedinicnaCijenaBezPdv: parseFloat(this.currentItem.jedinicnaCijenaBezPdv) || 0,
        jedinicnaCijenaSPdv: parseFloat(this.currentItem.jedinicnaCijenaSPdv) || 0,
        jedinicnaCijenaSRabatom: this.currentItem.jedinicnaCijenaSRabatom || 0,
        rabat: parseFloat(this.currentItem.rabat) || 0,
        stopaPdv: parseFloat(this.currentItem.stopaPdv) || 0,
        ukupnaCijenaBezPdv: parseFloat(this.currentItem.ukupnaCijenaBezPdv) || 0,
        iznosPdv: parseFloat(this.currentItem.iznosPdv) || 0,
        ukupnaCijenaSPdv: parseFloat(this.currentItem.ukupnaCijenaSPdv) || 0,
        povratnaNaknadaIznos: parseFloat(this.currentItem.povratnaNaknadaIznos) || 0, // Save povratna naknada amount
        item: this.currentItem.item,
        manualInput: this.manualInputMode // Save the manual input flag
      }

      // Add or update item
      const isNewItem = this.editingIndex === null
      if (this.editingIndex !== null) {
        this.items.splice(this.editingIndex, 1, itemToSave)
      } else {
        this.items.push(itemToSave)
      }

      this.closeItemModal()

      // Scroll to newly added item
      if (isNewItem) {
        this.$nextTick(() => {
          // Set selected index to the newly added item (last item)
          this.selectedItemIndex = this.items.length - 1

          // Scroll to show the new item
          const scrollContainer = document.querySelector('.items-list')
          if (scrollContainer) {
            // Scroll to bottom with smooth animation
            scrollContainer.scrollTo({
              top: scrollContainer.scrollHeight,
              behavior: 'smooth'
            })
          }
        })
      }
    },
    async editItem (index) {
      const item = this.items[index]

      // Update selected index when clicking on item
      this.selectedItemIndex = index

      // Get available units from item.item using same logic as openModalForItem
      const availableUnits = []
      if (item.item?.warehouse_units?.units) {
        // Use Object.keys to get unit IDs (keys), then access the unit object
        Object.keys(item.item.warehouse_units.units).forEach(unitKey => {
          const unit = item.item.warehouse_units.units[unitKey]
          availableUnits.push({
            id: unitKey, // Unit ID is the key in the warehouse_units.units object
            name: unit.storage_unit, // Use storage_unit as display name
            storage_amount: unit.storage_amount,
            base_unit: unit.base_unit || false,
            default_store: unit.default_store || false
          })
        })
      } else if (item.item?.storage_unit) {
        // Fallback to storage_unit if no warehouse_units
        availableUnits.push({
          id: item.item.storage_unit,
          name: item.item.storage_unit
        })
      } else {
        // Last resort fallback
        availableUnits.push({
          id: 'kom',
          name: 'kom'
        })
      }

      // Get retail price from saved kalkulacija data (when editing) or fetch from location_pricelist (when adding new)
      let retailPriceWithoutPdv = null
      let retailPriceWithPdv = null
      let retailPriceCurrency = null
      let retailPriceTaxRate = null

      // Ako postoje spremljeni podaci u kalkulaciji, dohvati cijenu odatle
      if (item.kalkulacija?.cijena) {
        const kalkulacijaCijena = item.kalkulacija.cijena

        // Dohvati cijenu S PDV-om (spremljena u centima)
        retailPriceWithPdv = Math.round(kalkulacijaCijena.cijena_s_pdv || 0) / 100
        retailPriceCurrency = 'EUR'

        // Get povratna naknada first
        let povratnaNaknadaPerUnit = 0
        if (item.item?.naknade?.povratna?.amount) {
          povratnaNaknadaPerUnit = item.item.naknade.povratna.amount / 100 // Convert from cents to EUR
        }

        // Dohvati PDV stopu (spremljena kao 2500 za 25%)
        const taxRate = (kalkulacijaCijena.pdv_stopa || 0) / 100
        retailPriceTaxRate = taxRate

        if (taxRate > 0) {
          // NOVO: Prvo oduzmi povratnu naknadu od cijene s PDV-om
          const priceAfterDeposit = retailPriceWithPdv - povratnaNaknadaPerUnit

          // Zatim izračunaj osnovicu (cijenu bez PDV-a)
          retailPriceWithoutPdv = Math.round((priceAfterDeposit / (1 + taxRate / 100)) * 100) / 100
        } else {
          // Nema PDV-a, samo oduzmi povratnu naknadu
          retailPriceWithoutPdv = Math.round((retailPriceWithPdv - povratnaNaknadaPerUnit) * 100) / 100
        }
      } else {
        // Ako nema spremljenih podataka, dohvati iz location_pricelist
        try {
          const itemId = item.id || item.item?.id
          if (this.selectedLocation && this.selectedLocation.id && itemId) {
            const pricelistDocRef = doc(df, `location_pricelist/${this.selectedLocation.id}/items/${itemId}`)
            const pricelistDoc = await getDoc(pricelistDocRef)

            if (pricelistDoc.exists()) {
              const pricelistData = pricelistDoc.data()

              // Get first active currency price (usually EUR)
              if (pricelistData.prices) {
                const currencies = Object.keys(pricelistData.prices)
                for (const currency of currencies) {
                  const priceInfo = pricelistData.prices[currency]
                  if (priceInfo.active && priceInfo.price) {
                    retailPriceCurrency = currency
                    // ISPRAVKA: priceInfo.price je cijena S PDV-om (stored in cents)
                    retailPriceWithPdv = Math.round(priceInfo.price) / 100

                    // Get povratna naknada first
                    let povratnaNaknadaPerUnit = 0
                    if (item.item?.naknade?.povratna?.amount) {
                      povratnaNaknadaPerUnit = item.item.naknade.povratna.amount / 100 // Convert from cents to EUR
                    }

                    // Calculate price WITHOUT PDV if taxes are defined
                    if (priceInfo.taxes && Array.isArray(priceInfo.taxes) && priceInfo.taxes.length > 0) {
                      // ISPRAVKA: taxRate je pohranjen kao 2500 za 25%, trebamo podijeliti sa 100
                      const taxRate = (priceInfo.taxes[0].rate || 0) / 100
                      retailPriceTaxRate = taxRate

                      // NOVO: Prvo oduzmi povratnu naknadu od cijene s PDV-om
                      const priceAfterDeposit = retailPriceWithPdv - povratnaNaknadaPerUnit

                      // Zatim izračunaj osnovicu (cijenu bez PDV-a)
                      retailPriceWithoutPdv = Math.round((priceAfterDeposit / (1 + taxRate / 100)) * 100) / 100
                    } else {
                      retailPriceTaxRate = 0
                      // No tax, just subtract povratna naknada
                      retailPriceWithoutPdv = Math.round((retailPriceWithPdv - povratnaNaknadaPerUnit) * 100) / 100
                    }
                    break // Use first active currency
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error('Error fetching retail price:', error)
          // Don't show error to user, just continue without retail price
        }
      }

      this.currentItem = {
        ...item,
        stock: item.item?.stock || 0,
        lastPrice: item.item?.last_price || 0,
        availableUnits: availableUnits,
        // Round all price fields to 2 decimals when loading
        jedinicnaCijenaBezPdv: item.jedinicnaCijenaBezPdv ? Math.round(item.jedinicnaCijenaBezPdv * 100) / 100 : item.jedinicnaCijenaBezPdv,
        jedinicnaCijenaSPdv: item.jedinicnaCijenaSPdv ? Math.round(item.jedinicnaCijenaSPdv * 100) / 100 : item.jedinicnaCijenaSPdv,
        ukupnaCijenaBezPdv: item.ukupnaCijenaBezPdv ? Math.round(item.ukupnaCijenaBezPdv * 100) / 100 : item.ukupnaCijenaBezPdv,
        iznosPdv: item.iznosPdv ? Math.round(item.iznosPdv * 100) / 100 : item.iznosPdv,
        ukupnaCijenaSPdv: item.ukupnaCijenaSPdv ? Math.round(item.ukupnaCijenaSPdv * 100) / 100 : item.ukupnaCijenaSPdv,
        povratnaNaknadaIznos: item.povratnaNaknadaIznos ? Math.round(item.povratnaNaknadaIznos * 100) / 100 : item.povratnaNaknadaIznos || 0,
        // Retail prices from location_pricelist
        retailPriceWithoutPdv: retailPriceWithoutPdv,
        retailPriceWithPdv: retailPriceWithPdv,
        retailPriceCurrency: retailPriceCurrency,
        retailPriceTaxRate: retailPriceTaxRate
      }
      this.editingIndex = index

      // Restore manual input mode from saved item
      this.manualInputMode = item.manualInput || false

      this.itemModal = true

      // Focus and select quantity field
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.kolicinaField) {
            const input = this.$refs.kolicinaField.$el.querySelector('input')
            if (input) {
              input.focus()
              input.select()
            }
          }
        }, 150)
      })
    },
    deleteItem (index) {
      this.confirm({
        title: 'Brisanje artikla',
        message: 'Jeste li sigurni da želite izbrisati ovaj artikl?',
        options: {
          toolbar: true,
          width: 410,
          confirmText: 'Obriši',
          cancelText: 'Odustani'
        }
      }).then(async (resp) => {
        this.confirmClose()
        if (resp) {
          this.items.splice(index, 1)
          // Adjust selected index after deletion
          if (this.selectedItemIndex >= this.items.length) {
            this.selectedItemIndex = this.items.length - 1
          }
        }
      })
    },
    closeItemModal () {
      this.itemModal = false
      this.currentItem = {}
      this.editingIndex = null
      this.manualInputMode = false
    },
    async loadKalkulacijaData (documentId = null, warehouseId = null) {
      // If documentId is provided, fetch from Firestore first
      let kalkulacija = this.kalkulacija

      if (documentId && warehouseId) {
        try {
          const docRef = doc(df, `warehouses/${warehouseId}/delivery_notes/${documentId}`)
          const docSnap = await getDoc(docRef)

          if (docSnap.exists()) {
            kalkulacija = { ...docSnap.data(), id: docSnap.id }
          } else {
            this.showMsgBox({
              text: 'Kalkulacija dokument nije pronađen.',
              actions: ['cancel'],
              cancelBtnText: this.$t('$vuetify.close'),
              color: 'error'
            })
            return
          }
        } catch (error) {
          console.error('Error fetching kalkulacija document:', error)
          this.showMsgBox({
            text: 'Greška pri učitavanju kalkulacije.',
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'error'
          })
          return
        }
      }

      if (!kalkulacija) return

      this.loading = true

      // Spremi učitanu kalkulaciju za korištenje u computed properties
      this.loadedKalkulacija = kalkulacija

      // Debug: prikaži dostupna polja u kalkulaciji
      console.log('Kalkulacija objekt ključevi:', Object.keys(kalkulacija))
      console.log('Kalkulacija objekt:', kalkulacija)

      try {
        // 1. Učitaj warehouse
        const warehouseDoc = await getDoc(doc(df, `warehouses/${kalkulacija.warehouse_id}`))
        if (warehouseDoc.exists()) {
          const warehouseData = warehouseDoc.data()
          this.selectedWarehouse = { ...warehouseData, id: warehouseDoc.id }
          this.warehouses = [this.selectedWarehouse]

          // Ne postavljaj listener za update akciju jer delivery_counter neće biti ažuriran
          // Listener će biti postavljen samo za 'add' akciju kroz onWarehouseChange
          if (this.currentAkcija !== 'update') {
            this.onWarehouseChange()
          }

          // Za uređivanje (update), učitaj interni broj primke iz same kalkulacije, ne iz skladišta
          // Kod dodavanja nove kalkulacije (add), interni broj primke se postavlja iz onWarehouseChange
          // Podržava delivery_note_id, interniBrojPrimke, i interni_broj_primke za backward compatibility
          const interniBroj = kalkulacija.delivery_note_id || kalkulacija.interniBrojPrimke || kalkulacija.interni_broj_primke
          if (interniBroj) {
            this.interniBrojPrimke = interniBroj.toString()
          } else {
            // Fallback ako ne postoji u kalkulaciji
            this.interniBrojPrimke = '1'
          }
        }

        // 2. Učitaj location
        if (kalkulacija.location_id) {
          const locationDoc = await getDoc(doc(df, `locations/${kalkulacija.location_id}`))
          if (locationDoc.exists()) {
            const locationData = locationDoc.data()
            this.selectedLocation = { ...locationData, id: locationDoc.id }
            this.locations = [this.selectedLocation]
          }
        }

        // 3. Učitaj dobavljače i selektiraj trenutnog preko trigram pretrage
        if (kalkulacija.customer_name) {
          await this.searchDobavljaci(kalkulacija.customer_name)
          this.selectedDobavljac = this.dobavljaci.find(
            d => d.name === kalkulacija.customer_name
          )
        }

        // 4. Postavi form polja
        this.selectedNAcinPlacanja = this.nacinplacanja.find(
          np => np.value === kalkulacija.fob_description
        ) || this.nacinplacanja[0]

        this.invoiceDate = kalkulacija.created * 1000
        this.brojTemelja = kalkulacija.delivery_number // Broj temelja
        // NOTE: interniBrojPrimke se već učitao gore (linija 2492-2497)

        // 5. Sačuvaj metode izračuna (handle negative sa Math.abs)
        this.rabatCalcType = Math.abs(kalkulacija.rabat_calc_type || 1)
        this.porezCalcType = Math.abs(kalkulacija.porez_calc_type || 1)

        // 6. Transformiraj extended_items u items array
        this.items = []

        if (kalkulacija.extended_items) {
          for (const itemId in kalkulacija.extended_items) {
            const extItem = kalkulacija.extended_items[itemId]

            // Preskoči povratna naknada (id === '-1')
            if (extItem.id === '-1') continue

            // Učitaj full item data za warehouse_units
            let fullItem = extItem.item
            try {
              const itemDocRef = doc(df, `companies/${state.getCurrentCompany().id}/items/${extItem.id}`)
              const itemDoc = await getDoc(itemDocRef)
              if (itemDoc.exists()) {
                fullItem = { ...itemDoc.data(), ...extItem.item }
              }
            } catch (error) {
              console.error('Error fetching item:', error)
            }

            // Izvuci mjernu jedinicu
            const availableUnits = []
            if (fullItem.warehouse_units?.units) {
              Object.keys(fullItem.warehouse_units.units).forEach(unitKey => {
                const unit = fullItem.warehouse_units.units[unitKey]
                availableUnits.push({
                  id: unitKey,
                  name: unit.storage_unit,
                  storage_amount: unit.storage_amount,
                  base_unit: unit.base_unit || false,
                  default_store: unit.default_store || false
                })
              })
            }

            const unitId = extItem.warehouse_data.received_amount_measure_unit || 'kom'
            const unitName = availableUnits.find(u => u.id === unitId)?.name || unitId

            // Izračunaj količinu (trebat će za povratnu naknadu)
            const kolicina = (extItem.warehouse_data.received_amount_quantity || 0) / 1000

            // Izračunaj povratnu naknadu ako artikl ima tu informaciju
            let povratnaNaknadaIznos = 0
            if (fullItem.naknade && fullItem.naknade.povratna && fullItem.naknade.povratna.amount) {
              const amountPerUnit = fullItem.naknade.povratna.amount / 100 // Iz centi u eure
              povratnaNaknadaIznos = Math.round(kolicina * amountPerUnit * 100) / 100
            }

            // KRITIČNO: Transformacija podataka (dijeljenje)
            const transformedItem = {
              id: extItem.id,
              artikl: extItem.item.name,
              code: extItem.item.code || '',
              stock: extItem.item.stock || 0,
              lastPrice: extItem.item.last_price || 0,
              item: fullItem,
              availableUnits: availableUnits,

              // Dijeli sa mnoziteljima korištenim u Firestore storage
              kolicina: kolicina,
              jedinicnaCijenaBezPdv: (extItem.warehouse_data.received_amount_purchase_price || 0) / 100000,
              jedinicnaCijenaSPdv: ((extItem.warehouse_data.received_amount_purchase_price || 0) / 100000) *
                                   (1 + ((extItem.warehouse_data.vat || 0) / 100) / 100),
              jedinicnaCijenaSRabatom: (extItem.warehouse_data.purchase_price || 0) / 100000,
              rabat: (extItem.warehouse_data.supplier_rebate || 0) / 100,
              stopaPdv: (extItem.warehouse_data.vat || 0) / 100,
              ukupnaCijenaBezPdv: (extItem.warehouse_data.value || 0) / 10000,
              iznosPdv: (extItem.warehouse_data.vat_amount || 0) / 100,
              ukupnaCijenaSPdv: ((extItem.warehouse_data.value || 0) / 10000) +
                                ((extItem.warehouse_data.vat_amount || 0) / 100),
              povratnaNaknadaIznos: povratnaNaknadaIznos,

              mjernaJedinica: unitId,
              mjernaJedinicaNaziv: unitName,

              // Dodaj kalkulacija objekt ako postoji (za prikaz maloprodajne cijene)
              kalkulacija: extItem.kalkulacija || null
            }

            this.items.push(transformedItem)
          }
        }
      } catch (error) {
        console.error('Error loading kalkulacija data:', error)
        this.showMsgBox({
          text: 'Greška pri učitavanju podataka kalkulacije.',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    calculateItemTotals () {
      const kolicina = parseFloat(this.currentItem.kolicina) || 0
      const cijenaBezPdv = parseFloat(this.currentItem.jedinicnaCijenaBezPdv) || 0
      const rabat = parseFloat(this.currentItem.rabat) || 0
      const stopaPdv = parseFloat(this.currentItem.stopaPdv) || 0

      let cijenaSDiskontom = 0
      let ukupnoBezPdv = 0
      let cijenaZaRacunanje = 0

      // Apply discount based on selected calculation method
      switch (this.rabatCalcType) {
        case 1: {
          // S JEDINIČNOM CIJENOM - apply discount to unit price
          cijenaZaRacunanje = cijenaBezPdv
          // 1. Primijeni rabat na jediničnu cijenu i zaokruži na 2 decimale
          cijenaSDiskontom = Math.round((cijenaBezPdv * (1 - rabat / 100)) * 100) / 100
          // 2. Množi zaokruženu cijenu s količinom i zaokruži na 2 decimale
          ukupnoBezPdv = Math.round((kolicina * cijenaSDiskontom) * 100) / 100

          console.log('=== IZRAČUN RABATA (S jediničnom cijenom) ===')
          console.log('Količina:', kolicina)
          console.log('Cijena bez PDV:', cijenaBezPdv.toFixed(2), '€')
          console.log('Ukupna cijena prije rabata:', (cijenaBezPdv * kolicina).toFixed(2), '€')
          console.log('Rabat [Cijena s kojom računam:', cijenaZaRacunanje.toFixed(2), '€, Rabat:', rabat + '%]')
          console.log('Cijena s rabatom (zaokruženo):', cijenaSDiskontom.toFixed(2), '€')
          console.log('Izračun: ', kolicina, '×', cijenaSDiskontom.toFixed(2), '=', (kolicina * cijenaSDiskontom).toFixed(2))
          console.log('UKUPNO BEZ PDV (zaokruženo):', ukupnoBezPdv.toFixed(2), '€')
          console.log('==========================================\n')
          break
        }
        case 2: {
          // S UKUPNOM CIJENOM - apply discount to total price
          // 1. Količina × jedinična cijena, zaokruženo na 2 decimale
          const ukupnoPrijeRabata = Math.round((cijenaBezPdv * kolicina) * 100) / 100
          cijenaZaRacunanje = ukupnoPrijeRabata
          // 2. Primijeni rabat na zaokruženi iznos, zaokruži rezultat na 2 decimale
          ukupnoBezPdv = Math.round((ukupnoPrijeRabata * (1 - rabat / 100)) * 100) / 100
          // 3. Vrati nazad u jediničnu cijenu s rabatom
          cijenaSDiskontom = ukupnoBezPdv / kolicina

          console.log('=== IZRAČUN RABATA (S ukupnom cijenom) ===')
          console.log('Količina:', kolicina)
          console.log('Cijena bez PDV:', cijenaBezPdv.toFixed(2), '€')
          console.log('Ukupna cijena prije rabata (zaokruženo):', ukupnoPrijeRabata.toFixed(2), '€')
          console.log('Rabat [Cijena s kojom računam:', cijenaZaRacunanje.toFixed(2), '€, Rabat:', rabat + '%]')
          console.log('UKUPNO BEZ PDV (nakon rabata, zaokruženo):', ukupnoBezPdv.toFixed(2), '€')
          console.log('Jedinična cijena s rabatom:', cijenaSDiskontom.toFixed(6), '€')
          console.log('==========================================\n')
          break
        }
        default: {
          // Fallback to method 1
          cijenaZaRacunanje = cijenaBezPdv
          cijenaSDiskontom = cijenaBezPdv * (1 - rabat / 100)
          ukupnoBezPdv = kolicina * cijenaSDiskontom
          break
        }
      }

      // Calculate PDV amount
      const iznosPdv = ukupnoBezPdv * (stopaPdv / 100)

      // Calculate total with PDV
      const ukupnoSPdv = ukupnoBezPdv + iznosPdv

      // Update current item - round to 2 decimals
      this.currentItem.jedinicnaCijenaSRabatom = Math.round(cijenaSDiskontom * 100) / 100
      this.currentItem.ukupnaCijenaBezPdv = Math.round(ukupnoBezPdv * 100) / 100
      this.currentItem.iznosPdv = Math.round(iznosPdv * 100) / 100
      this.currentItem.ukupnaCijenaSPdv = Math.round(ukupnoSPdv * 100) / 100

      // Calculate unit price with PDV - round to 2 decimals
      const jedinicnaCijenaSPdv = cijenaBezPdv * (1 + stopaPdv / 100)
      this.currentItem.jedinicnaCijenaSPdv = Math.round(jedinicnaCijenaSPdv * 100) / 100

      // Calculate povratna naknada if exists
      if (this.currentItem.item && this.currentItem.item.naknade && this.currentItem.item.naknade.povratna) {
        const amountPerUnit = (this.currentItem.item.naknade.povratna.amount || 0) / 100 // Convert from cents to EUR
        const povratnaNaknadaTotal = kolicina * amountPerUnit
        this.currentItem.povratnaNaknadaIznos = Math.round(povratnaNaknadaTotal * 100) / 100
      } else {
        this.currentItem.povratnaNaknadaIznos = 0
      }
    },
    calculateFromPriceWithPdv () {
      const cijenasPdv = parseFloat(this.currentItem.jedinicnaCijenaSPdv) || 0
      const stopaPdv = parseFloat(this.currentItem.stopaPdv) || 0

      // Calculate price without PDV from price with PDV
      const cijenaBezPdv = cijenasPdv / (1 + stopaPdv / 100)
      this.currentItem.jedinicnaCijenaBezPdv = Math.round(cijenaBezPdv * 100) / 100

      this.calculateItemTotals()
    },
    onUnitChange () {
      // Update unit name
      const selectedUnit = this.currentItem.availableUnits.find(
        u => u.id === this.currentItem.mjernaJedinica
      )
      if (selectedUnit) {
        this.currentItem.mjernaJedinicaNaziv = selectedUnit.name
      }
    },
    selectAllOnFocus (event) {
      // Select all text in input field when focused
      event.target.select()
    },
    normalizeDecimalInput (field, calculateFn) {
      // Normalize decimal separator - replace comma with dot
      // This method is called on @input event for number fields
      const value = this.currentItem[field]
      if (value && typeof value === 'string' && value.includes(',')) {
        this.currentItem[field] = value.replace(',', '.')
      }
      // Call the calculation function if provided
      if (calculateFn && !this.manualInputMode) {
        calculateFn()
      }
    },
    handleCommaKeydown (event, field) {
      const key = event.key
      const keyCode = event.keyCode

      // Allow control keys: Backspace, Delete, Tab, Escape, Enter, Home, End, Arrow keys
      if ([8, 9, 13, 27, 35, 36, 37, 38, 39, 40, 46].indexOf(keyCode) !== -1) {
        return
      }

      // Allow Ctrl/Cmd + A/C/V/X (select all, copy, paste, cut)
      if ((event.ctrlKey || event.metaKey) && [65, 67, 86, 88].indexOf(keyCode) !== -1) {
        return
      }

      // Check if comma key is pressed - convert to dot
      if (key === ',' || keyCode === 188 || keyCode === 110 || event.code === 'NumpadDecimal') {
        event.preventDefault()

        const currentValue = String(this.currentItem[field] || '')

        // Check if there's already a dot in the value
        if (!currentValue.includes('.')) {
          this.currentItem[field] = currentValue + '.'

          // Trigger input event manually to update calculations
          this.$nextTick(() => {
            const inputElement = event.target
            if (inputElement) {
              inputElement.dispatchEvent(new Event('input', { bubbles: true }))
            }
          })
        }
        return
      }

      // Allow dot/period (keyCode 190 for main keyboard, 110 for numpad - but 110 handled above as comma)
      if (key === '.' || keyCode === 190) {
        const currentValue = String(this.currentItem[field] || '')
        // Prevent multiple dots
        if (currentValue.includes('.')) {
          event.preventDefault()
        }
        return
      }

      // Allow numbers 0-9 (main keyboard 48-57, numpad 96-105)
      if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)) {
        return
      }

      // Allow minus sign (keyCode 189 main keyboard, 109 numpad)
      if (key === '-' || keyCode === 189 || keyCode === 109) {
        const currentValue = String(this.currentItem[field] || '')
        // Dopusti minus samo kad je kursor na početku polja i još nema minusa
        if (currentValue.includes('-') || event.target.selectionStart !== 0) {
          event.preventDefault()
        }
        return
      }

      // Block everything else (letters, spaces, special characters)
      event.preventDefault()
    },
    recalculateAllItems () {
      // Recalculate all items in the list when calculation method changes
      if (!this.items || this.items.length === 0) return

      this.items = this.items.map(item => {
        const kolicina = parseFloat(item.kolicina) || 0
        const cijenaBezPdv = parseFloat(item.jedinicnaCijenaBezPdv) || 0
        const rabat = parseFloat(item.rabat) || 0
        const stopaPdv = parseFloat(item.stopaPdv) || 0

        let cijenaSDiskontom = 0
        let ukupnoBezPdv = 0

        // Apply discount based on selected calculation method
        switch (this.rabatCalcType) {
          case 1: {
            // S JEDINIČNOM CIJENOM - apply discount to unit price
            cijenaSDiskontom = Math.round((cijenaBezPdv * (1 - rabat / 100)) * 100) / 100
            ukupnoBezPdv = Math.round((kolicina * cijenaSDiskontom) * 100) / 100
            break
          }
          case 2: {
            // S UKUPNOM CIJENOM - apply discount to total price
            const ukupnoPrijeRabata = Math.round((cijenaBezPdv * kolicina) * 100) / 100
            ukupnoBezPdv = Math.round((ukupnoPrijeRabata * (1 - rabat / 100)) * 100) / 100
            cijenaSDiskontom = ukupnoBezPdv / kolicina
            break
          }
          default: {
            cijenaSDiskontom = Math.round((cijenaBezPdv * (1 - rabat / 100)) * 100) / 100
            ukupnoBezPdv = Math.round((kolicina * cijenaSDiskontom) * 100) / 100
            break
          }
        }

        // Calculate PDV amount
        const iznosPdv = ukupnoBezPdv * (stopaPdv / 100)

        // Calculate total with PDV
        const ukupnoSPdv = ukupnoBezPdv + iznosPdv

        // Return updated item with recalculated values
        return {
          ...item,
          jedinicnaCijenaSRabatom: Math.round(cijenaSDiskontom * 100) / 100,
          ukupnaCijenaBezPdv: Math.round(ukupnoBezPdv * 100) / 100,
          iznosPdv: Math.round(iznosPdv * 100) / 100,
          ukupnaCijenaSPdv: Math.round(ukupnoSPdv * 100) / 100
        }
      })

      console.log('=== REKALKULACIJA SVIH ARTIKALA ===')
      console.log('Metoda rabata:', this.rabatCalcType === 1 ? 'S jediničnom cijenom' : 'S ukupnom cijenom')
      console.log('Metoda poreza:', this.porezCalcType === 1 ? 'Po artiklima' : 'Po ukupnoj cijeni')
      console.log('Broj artikala:', this.items.length)
      console.log('====================================\n')
    },
    formatCurrency (value) {
      const num = parseFloat(value)
      if (isNaN(num)) return '0.00 €'
      return `${num.toFixed(2)} €`
    },
    formatRetailPrice (value) {
      const num = parseFloat(value)
      if (isNaN(num)) return '0,00'
      // Format with comma as decimal separator (European format)
      return num.toFixed(2).replace('.', ',')
    },
    formatNumber (value) {
      const num = parseFloat(value)
      if (isNaN(num)) return '0'
      return num.toFixed(2)
    },
    formatStock (stock) {
      if (!stock) return '0'
      return (stock / 1000).toFixed(2)
    },
    getItemPrice (searchItem) {
      if (searchItem.warehouse_data &&
          searchItem.warehouse_data.quantity_by_purchase_price &&
          Array.isArray(searchItem.warehouse_data.quantity_by_purchase_price) &&
          searchItem.warehouse_data.quantity_by_purchase_price.length > 0) {
        const lastEntry = searchItem.warehouse_data.quantity_by_purchase_price[
          searchItem.warehouse_data.quantity_by_purchase_price.length - 1
        ]
        const price = (lastEntry.purchase_price || 0) / 100
        return this.formatCurrency(price)
      }
      return this.formatCurrency(0)
    },
    getItemUnit (searchItem) {
      if (searchItem.item && searchItem.item.warehouse_units && searchItem.item.warehouse_units.units) {
        const units = Object.values(searchItem.item.warehouse_units.units)
        const defaultUnit = units.find(u => u.default_store === true)
        if (defaultUnit && defaultUnit.storage_unit) {
          return defaultUnit.storage_unit
        }
      }
      return 'KOM'
    },
    focusSearchField () {
      this.$nextTick(() => {
        if (this.$refs.searchField) {
          this.$refs.searchField.focus()
        }
      })
    },
    clearSearch () {
      this.searchQuery = ''
      this.searchResults = []
      this.selectedResultIndex = 0
      this.showNoResults = false
    },
    navigateResults (direction) {
      if (this.searchResults.length === 0) return

      if (direction === 'down') {
        this.selectedResultIndex =
          (this.selectedResultIndex + 1) % this.searchResults.length
      } else if (direction === 'up') {
        this.selectedResultIndex =
          (this.selectedResultIndex - 1 + this.searchResults.length) % this.searchResults.length
      }

      // Scroll selected result into view, accounting for header
      this.$nextTick(() => {
        const selectedResult = document.querySelector('.result-selected')
        const resultsContainer = document.querySelector('.search-results')
        const resultsHeader = document.querySelector('.search-results-header')

        if (selectedResult && resultsContainer && resultsHeader) {
          // Get bounding rectangles for accurate positioning
          const resultRect = selectedResult.getBoundingClientRect()
          const containerRect = resultsContainer.getBoundingClientRect()
          const headerRect = resultsHeader.getBoundingClientRect()

          // Calculate positions relative to the container
          const resultTopRelativeToContainer = resultRect.top - containerRect.top
          const headerBottomRelativeToContainer = headerRect.bottom - containerRect.top

          // Result is hidden under header
          if (resultTopRelativeToContainer < headerBottomRelativeToContainer) {
            const currentScrollTop = resultsContainer.scrollTop
            const scrollOffset = headerBottomRelativeToContainer - resultTopRelativeToContainer
            resultsContainer.scrollTo({
              top: currentScrollTop - scrollOffset - 4,
              behavior: 'smooth'
            })
          } else if (resultRect.bottom > containerRect.bottom) {
            // Result is below visible area
            const currentScrollTop = resultsContainer.scrollTop
            const scrollOffset = resultRect.bottom - containerRect.bottom
            resultsContainer.scrollTo({
              top: currentScrollTop + scrollOffset + 4,
              behavior: 'smooth'
            })
          }
        }
      })
    },
    selectFirstResult () {
      if (this.searchResults.length > 0) {
        this.openModalForItem(this.searchResults[this.selectedResultIndex])
      }
    },
    // Items table navigation
    navigateItemsTable (direction) {
      if (this.items.length === 0) return

      if (direction === 'down') {
        if (this.selectedItemIndex < this.items.length - 1) {
          this.selectedItemIndex++
        } else {
          this.selectedItemIndex = 0 // Wrap around to first item
        }
      } else if (direction === 'up') {
        if (this.selectedItemIndex > 0) {
          this.selectedItemIndex--
        } else if (this.selectedItemIndex === -1) {
          this.selectedItemIndex = this.items.length - 1 // Start from last item
        } else {
          this.selectedItemIndex = this.items.length - 1 // Wrap around to last item
        }
      }

      // Scroll selected item into view, accounting for sticky header
      this.$nextTick(() => {
        const selectedRow = document.querySelector('.item-row-selected')
        const scrollContainer = document.querySelector('.items-list')
        const stickyHeader = document.querySelector('.items-header-wrapper')

        if (selectedRow && scrollContainer && stickyHeader) {
          // Get bounding rectangles for accurate positioning
          const rowRect = selectedRow.getBoundingClientRect()
          const containerRect = scrollContainer.getBoundingClientRect()
          const headerRect = stickyHeader.getBoundingClientRect()

          // Calculate positions relative to the container
          const rowTopRelativeToContainer = rowRect.top - containerRect.top
          const headerBottomRelativeToContainer = headerRect.bottom - containerRect.top

          // Row is hidden under sticky header
          if (rowTopRelativeToContainer < headerBottomRelativeToContainer) {
            // Scroll so the row is visible just below the header
            const currentScrollTop = scrollContainer.scrollTop
            const scrollOffset = headerBottomRelativeToContainer - rowTopRelativeToContainer
            scrollContainer.scrollTo({
              top: currentScrollTop - scrollOffset - 8,
              behavior: 'smooth'
            })
          } else if (rowRect.bottom > containerRect.bottom) {
            // Row is below visible area
            const currentScrollTop = scrollContainer.scrollTop
            const scrollOffset = rowRect.bottom - containerRect.bottom
            scrollContainer.scrollTo({
              top: currentScrollTop + scrollOffset + 8,
              behavior: 'smooth'
            })
          }
        }
      })
    },
    // Keyboard Shortcuts
    setupKeyboardShortcuts () {
      document.addEventListener('keydown', this.handleGlobalKeydown)
    },
    handleGlobalKeydown (event) {
      // Check if we're in a modal or input field (except search field)
      const isInModal = this.itemModal
      const isInOtherInput = event.target.tagName === 'INPUT' ||
                            event.target.tagName === 'TEXTAREA' ||
                            event.target.isContentEditable

      // F2 - Focus search / Add new row
      if (event.key === 'F2') {
        event.preventDefault()
        this.focusSearchField()
      }

      // Ctrl+Enter - Submit form
      if (event.ctrlKey && event.key === 'Enter') {
        event.preventDefault()
        this.presubmit()
      }

      // Ctrl+F - Focus search
      if (event.ctrlKey && event.key === 'f') {
        event.preventDefault()
        this.focusSearchField()
      }

      // Escape - Clear search
      if (event.key === 'Escape' && this.searchQuery) {
        event.preventDefault()
        this.clearSearch()
      }

      // Arrow navigation in items table (only when not in input/modal/search results)
      if (!isInModal && !isInOtherInput && this.searchResults.length === 0 && this.items.length > 0) {
        if (event.key === 'ArrowDown') {
          event.preventDefault()
          this.navigateItemsTable('down')
        } else if (event.key === 'ArrowUp') {
          event.preventDefault()
          this.navigateItemsTable('up')
        } else if (event.key === 'Enter' && this.selectedItemIndex >= 0) {
          event.preventDefault()
          this.editItem(this.selectedItemIndex)
        }
      }
    },
    handleBeforeUnload (event) {
      // Check if there are unsaved items
      if (this.items && this.items.length > 0) {
        // Modern browsers require returnValue to be set
        event.preventDefault()
        event.returnValue = ''
        return ''
      }
    },
    addRow () {
      if (this.tabulator.validate() !== true) return
      this.tabulator.addRow({}).then(function (row) {
        // Dobijte ćeliju prve kolone novog retka
        var cell = row.getCell('artikl')
        if (cell) {
          // Start editing the cell
          cell.edit()
        }
      })
    },
    zbroji (a, b) {
      // Pretvaranje a i b u brojeve ako su stringovi
      a = typeof a === 'string' ? a.replace(',', '.') : a
      b = typeof b === 'string' ? b.replace(',', '.') : b

      // Pretvaranje a i b u brojeve
      a = parseFloat(a) || 0
      b = parseFloat(b) || 0

      // Zbrajanje i formatiranje rezultata
      return (a + b).toFixed(2).replace('.', ',')
    },
    pomnozi (a, b) {
      // Pretvaranje a i b u brojeve ako su stringovi
      a = typeof a === 'string' ? a.replace(',', '.') : a
      b = typeof b === 'string' ? b.replace(',', '.') : b

      // Pretvaranje a i b u brojeve
      a = parseFloat(a) || 0
      b = parseFloat(b) || 0

      // Množenje i formatiranje rezultata
      const rezultat = (a * b).toFixed(2)

      // Vraćanje rezultata kao string sa zarezom umjesto točke
      return rezultat.replace('.', ',')
    },

    kalkulacijaCijene (inputdata) {
      const data = inputdata.getRow().getData()
      const update = {}

      let ukupnaCijenaBezPdv = data.kolicina * data.jedinicnaCijenaSRabatom
      let iznosPdv =
        data.kolicina * data.jedinicnaCijenaSRabatom * (data.stopaPdv / 100)
      let jedinicnaCijenaSRabatom =
        data.jedinicnaCijenaBezPdv * (1 - data.rabat / 100)
      let jedinicnaCijenaBezPdv =
        data.jedinicnaCijenaSRabatom / (1 - data.rabat / 100)

      switch (inputdata.getField()) {
        /** Kolicina */
        case 'kolicina':
          switch (this.selectedColumn) {
            case 'jedinicnaCijenaSPdv':
              jedinicnaCijenaSRabatom =
                data.jedinicnaCijenaSPdv / (1 + data.stopaPdv / 100)
              break
            case 'jedinicnaCijenaBezPdv':
              jedinicnaCijenaSRabatom =
                data.jedinicnaCijenaBezPdv * (1 - data.rabat / 100)
              break
          }

          update.jedinicnaCijenaSRabatom = jedinicnaCijenaSRabatom.toFixed(2)
          ukupnaCijenaBezPdv = inputdata.getValue() * jedinicnaCijenaSRabatom

          update.ukupnaCijenaBezPdv = ukupnaCijenaBezPdv.toFixed(2)

          /** Predporez */
          iznosPdv =
            data.kolicina * jedinicnaCijenaSRabatom * (data.stopaPdv / 100)
          update.iznosPdv = iznosPdv.toFixed(2)

          /** Cijena s PDV-om */
          if (data.jedinicnaCijenaBezPdv && data.stopaPdv) {
            update.jedinicnaCijenaSPdv = (
              data.jedinicnaCijenaSRabatom *
              (1 + data.stopaPdv / 100)
            ).toFixed(2)
          }
          /** Ukupno */
          update.ukupnaCijenaSPdv = (ukupnaCijenaBezPdv + iznosPdv).toFixed(2)
          break

        /** Nabavna cijena */
        case 'jedinicnaCijenaBezPdv':
          jedinicnaCijenaBezPdv = inputdata.getValue()

          /** Cijena */
          if (data.rabat !== '' && data.rabat !== undefined) {
            update.jedinicnaCijenaSRabatom = jedinicnaCijenaSRabatom.toFixed(2)
          } else update.jedinicnaCijenaSRabatom = jedinicnaCijenaBezPdv

          /** Cijena s PDV-om */
          if (jedinicnaCijenaBezPdv && data.stopaPdv) {
            update.jedinicnaCijenaSPdv = (
              jedinicnaCijenaSRabatom *
              (1 + data.stopaPdv / 100)
            ).toFixed(2)
          }
          /** Ukupno bez pdv */
          ukupnaCijenaBezPdv = data.kolicina * jedinicnaCijenaSRabatom
          update.ukupnaCijenaBezPdv = ukupnaCijenaBezPdv.toFixed(2)

          /** Predporez */
          iznosPdv =
            data.kolicina * jedinicnaCijenaSRabatom * (data.stopaPdv / 100)
          update.iznosPdv = iznosPdv.toFixed(2)
          /** Ukupno */
          update.ukupnaCijenaSPdv = this.zbroji(ukupnaCijenaBezPdv + iznosPdv)
          break

        /** Rabat */
        case 'rabat':
          switch (this.rabatCalcType) {
            // RADIMO S JEDINICNOM CIJENOM
            case 1: {
              switch (this.selectedColumn) {
                case 'jedinicnaCijenaSPdv':
                  jedinicnaCijenaSRabatom = parseFloat(
                    data.jedinicnaCijenaSPdv / (1 + data.stopaPdv / 100)
                  )
                  jedinicnaCijenaSRabatom =
                    jedinicnaCijenaSRabatom * (1 - inputdata.getValue() / 100)
                  break

                case 'jedinicnaCijenaBezPdv':
                  jedinicnaCijenaSRabatom =
                    data.jedinicnaCijenaBezPdv *
                    (1 - inputdata.getValue() / 100)
                  break
              }

              if (data.rabat !== '' && data.rabat !== undefined) {
                update.jedinicnaCijenaSRabatom =
                  jedinicnaCijenaSRabatom.toFixed(2)
              } else {
                update.jedinicnaCijenaSRabatom = data.jedinicnaCijenaBezPdv
              }

              ukupnaCijenaBezPdv = this.pomnozi(
                data.kolicina,
                jedinicnaCijenaSRabatom
              )
              update.ukupnaCijenaBezPdv = ukupnaCijenaBezPdv

              /** Predporez */
              iznosPdv =
                data.kolicina * jedinicnaCijenaSRabatom * (data.stopaPdv / 100)
              update.iznosPdv = iznosPdv.toFixed(2)

              /** Ukupno */
              update.ukupnaCijenaSPdv = this.zbroji(
                ukupnaCijenaBezPdv,
                iznosPdv
              )
              break
            }

            // RADIMO S UKUPNOM CIJENOM
            case 2: {
              switch (this.selectedColumn) {
                case 'jedinicnaCijenaSPdv': {
                  var ukupnaCijenaSPdv =
                    data.jedinicnaCijenaSPdv * data.kolicina
                  ukupnaCijenaSPdv =
                    ukupnaCijenaSPdv * (1 - inputdata.getValue() / 100)

                  ukupnaCijenaBezPdv =
                    ukupnaCijenaSPdv / (1 + data.stopaPdv / 100)
                  update.ukupnaCijenaBezPdv = ukupnaCijenaBezPdv.toFixed(2)

                  jedinicnaCijenaSRabatom = ukupnaCijenaBezPdv / data.kolicina
                  break
                }

                case 'jedinicnaCijenaBezPdv': {
                  ukupnaCijenaBezPdv =
                    data.jedinicnaCijenaBezPdv * data.kolicina

                  ukupnaCijenaBezPdv =
                    ukupnaCijenaBezPdv * (1 - inputdata.getValue() / 100)
                  update.ukupnaCijenaBezPdv = ukupnaCijenaBezPdv.toFixed(2)

                  jedinicnaCijenaSRabatom = ukupnaCijenaBezPdv / data.kolicina
                  break
                }
              }

              if (
                data.rabat !== '' &&
                data.rabat !== undefined &&
                data.rabat !== '0'
              ) {
                update.jedinicnaCijenaSRabatom =
                  jedinicnaCijenaSRabatom.toFixed(2)
              } else {
                update.jedinicnaCijenaSRabatom = data.jedinicnaCijenaBezPdv
                ukupnaCijenaBezPdv = this.pomnozi(
                  data.kolicina,
                  jedinicnaCijenaSRabatom
                )
                update.ukupnaCijenaBezPdv = ukupnaCijenaBezPdv
              }

              /** Predporez */
              iznosPdv =
                data.kolicina *
                parseFloat(jedinicnaCijenaSRabatom) *
                (data.stopaPdv / 100)
              update.iznosPdv = iznosPdv.toFixed(2)

              /** Ukupno */
              update.ukupnaCijenaSPdv = this.zbroji(
                ukupnaCijenaBezPdv,
                iznosPdv
              )

              break
            }
          }

          break

        /** Cijena */
        case 'jedinicnaCijenaSRabatom':
          jedinicnaCijenaSRabatom = inputdata.getValue()
          jedinicnaCijenaBezPdv =
            jedinicnaCijenaSRabatom / (1 - data.rabat / 100)
          /** Nabavna cijena */
          if (data.rabat !== '' && data.rabat !== undefined) {
            update.jedinicnaCijenaBezPdv = jedinicnaCijenaBezPdv.toFixed(2)
          } else update.jedinicnaCijenaBezPdv = jedinicnaCijenaSRabatom

          /** Cijena s PDV-om */
          if (jedinicnaCijenaBezPdv && data.stopaPdv) {
            update.jedinicnaCijenaSPdv = (
              jedinicnaCijenaSRabatom *
              (1 + data.stopaPdv / 100)
            ).toFixed(2)
          }

          /** Ukupno bez pdv */
          ukupnaCijenaBezPdv = data.kolicina * data.jedinicnaCijenaSRabatom
          update.ukupnaCijenaBezPdv = ukupnaCijenaBezPdv.toFixed(2)

          /** Predporez */
          iznosPdv =
            data.kolicina *
            data.jedinicnaCijenaSRabatom *
            (data.stopaPdv / 100)
          update.iznosPdv = iznosPdv.toFixed(2)

          /** Ukupno */
          update.ukupnaCijenaSPdv = this.zbroji(ukupnaCijenaBezPdv + iznosPdv)
          break

        /** PDV(%) */
        case 'stopaPdv':
          switch (this.selectedColumn) {
            case 'jedinicnaCijenaSPdv':
              jedinicnaCijenaSRabatom = parseFloat(
                data.jedinicnaCijenaSPdv / (1 + inputdata.getValue() / 100)
              )
              /** Cijena bez PDV-a */
              update.jedinicnaCijenaBezPdv = (
                jedinicnaCijenaSRabatom /
                (1 - data.rabat / 100)
              ).toFixed(2)
              break
            case 'jedinicnaCijenaBezPdv':
              jedinicnaCijenaSRabatom =
                data.jedinicnaCijenaBezPdv * (1 - data.rabat / 100)
              /** Cijena s PDV-om */
              if (data.jedinicnaCijenaBezPdv && inputdata.getValue()) {
                update.jedinicnaCijenaSPdv = (
                  jedinicnaCijenaSRabatom *
                  (1 + inputdata.getValue() / 100)
                ).toFixed(2)
              }
              break
          }
          /** Cijena s rabatom */
          update.jedinicnaCijenaSRabatom = jedinicnaCijenaSRabatom.toFixed(2)
          /** Ukupno bez PDV-a */
          ukupnaCijenaBezPdv = data.kolicina * jedinicnaCijenaSRabatom
          update.ukupnaCijenaBezPdv = ukupnaCijenaBezPdv.toFixed(2)

          /** Predporez */
          iznosPdv =
            data.kolicina *
            jedinicnaCijenaSRabatom *
            (inputdata.getValue() / 100)
          update.iznosPdv = iznosPdv.toFixed(2)

          /** Ukupno */
          update.ukupnaCijenaSPdv = this.zbroji(ukupnaCijenaBezPdv, iznosPdv)
          break

        /** Cijena s PDV-om */
        case 'jedinicnaCijenaSPdv':
          /** Cijena */
          jedinicnaCijenaSRabatom =
            data.jedinicnaCijenaSPdv / (1 + data.stopaPdv / 100)
          update.jedinicnaCijenaSRabatom = jedinicnaCijenaSRabatom.toFixed(2)

          /** Nabavna cijena */
          if (data.rabat !== '' && data.rabat !== undefined) {
            update.jedinicnaCijenaBezPdv = (
              jedinicnaCijenaSRabatom *
              (1 + data.rabat / 100)
            ).toFixed(2)
          } else {
            update.jedinicnaCijenaBezPdv = jedinicnaCijenaSRabatom.toFixed(2)
          }

          /** Ukupno bez pdv */
          ukupnaCijenaBezPdv = data.kolicina * jedinicnaCijenaSRabatom
          update.ukupnaCijenaBezPdv = ukupnaCijenaBezPdv.toFixed(2)

          /** Predporez */
          iznosPdv =
            data.kolicina * jedinicnaCijenaSRabatom * (data.stopaPdv / 100)
          update.iznosPdv = iznosPdv.toFixed(2)

          /** Ukupno */
          update.ukupnaCijenaSPdv = (ukupnaCijenaBezPdv + iznosPdv).toFixed(2)

          break
      }

      inputdata.getRow().update(update)
    },

    numberValidation (cell, num, parameters) {
      let allowZero = false
      if (parameters?.allowZero ?? false) {
        allowZero = true
      }
      if (!num || num === '' || (num === 0 && !allowZero)) return false
      var bla = num.toString().trim()
      if (bla === '') return false
      var number = bla.replace(/,/g, '.')
      number = parseFloat(number)
      if (allowZero && parseInt(Math.round(number * 100)) >= 0) return true
      if (parseInt(Math.round(number * 100)) > 0) return true
      return false
    },
    async getLocations () {
      this.showLocationSelector = false

      return df.collection('locations')
        .where('company_id', '==', state.getCurrentCompany().id)
        .get()
        .then(async (documentSnapshots) => {
          if (documentSnapshots.docs && !documentSnapshots.docs.empty) {
            documentSnapshots.docs.forEach((location) => {
              const loc = location.data()
              this.locations.push(loc)
            })
            this.locations = this.locations.sort((a, b) =>
              a.name.localeCompare(b.name)
            )
            // Auto-select first location and load warehouses
            if (this.locations.length >= 1 && !this.selectedLocation) {
              this.selectedLocation = this.locations[0]
              await this.getWarehouses()
            }
            this.$forceUpdate()
          }
        })
    },

    async searchDobavljaci (searchQuery) {
      try {
        this.loadingDobavljac = true
        const selectedOib = this.selectedDobavljac && this.selectedDobavljac.name === searchQuery &&
          this.selectedDobavljac.all && (this.selectedDobavljac.all.oib || (this.selectedDobavljac.all.oibs && this.selectedDobavljac.all.oibs[0]))
        const filterValue = selectedOib || searchQuery.split(',')[0].trim()
        const path = `/associates/${state.getCurrentCompany().id}/associate?filter=trigram(eq:${encodeURIComponent(filterValue)})`
        const response = await callAssociates('get', path)

        if (response && response.status === 200 && response.data && response.data.associates) {
          const newDobavljaci = Object.keys(response.data.associates)
            .map((key) => response.data.associates[key])
            .filter((associate) => associate.status === 'OK' && associate.associate_type && associate.associate_type.SUPPLIER)
            .map((associate) => ({
              name: associate.name,
              value: associate.id,
              all: associate
            }))
            .sort((a, b) => a.name.localeCompare(b.name))

          // If there's a selected supplier, ensure it stays in the list
          if (this.selectedDobavljac) {
            const selectedExists = newDobavljaci.find(d => d.name === this.selectedDobavljac.name)
            if (!selectedExists) {
              newDobavljaci.unshift(this.selectedDobavljac)
            }
          }

          this.dobavljaci = newDobavljaci
        } else {
          this.dobavljaci = []
        }
      } catch (error) {
        console.error('Error searching dobavljaci:', error)
        this.dobavljaci = []
      } finally {
        this.loadingDobavljac = false
      }
    },

    async getWarehouses () {
      this.warehouses = []
      return df.collection('warehouses')
        .where('location_id', '==', this.selectedLocation.id)
        .get()
        .then((documentSnapshots) => {
          if (documentSnapshots.docs && !documentSnapshots.docs.empty) {
            documentSnapshots.docs.forEach((warehouse) => {
              const loc = warehouse.data()
              this.warehouses.push(loc)
            })
            if (this.warehouses.length === 1) {
              this.selectedWarehouse = this.warehouses[0]
              // Ako je automatski odabrano skladište, postavi broj primke
              this.$nextTick(() => {
                this.onWarehouseChange()
              })
            }
            this.warehouses = this.warehouses.sort((a, b) =>
              a.name.localeCompare(b.name)
            )
            // Auto-select first warehouse if none selected or only one exists
            if (!this.selectedWarehouse || this.warehouses.length === 1) {
              this.selectedWarehouse = this.warehouses[0]
              // Postavi listener ako warehouse nije prethodno bio postavljen
              this.$nextTick(() => {
                this.onWarehouseChange()
              })
            }
            this.$forceUpdate()
          }
        })
    },
    onWarehouseChange () {
      // Ukloni postojeći listener ako postoji
      if (this.warehouseUnsubscribe) {
        this.warehouseUnsubscribe()
        this.warehouseUnsubscribe = null
      }

      // Postavi listener za warehouse ako je odabrano i nije update akcija
      if (this.selectedWarehouse && this.selectedWarehouse.id && this.currentAkcija !== 'update') {
        const warehouseRef = doc(df, `warehouses/${this.selectedWarehouse.id}`)

        // Postavi real-time listener
        this.warehouseUnsubscribe = onSnapshot(warehouseRef, (docSnap) => {
          if (docSnap.exists()) {
            const warehouseData = docSnap.data()
            const deliveryCounter = warehouseData.delivery_counter

            // Ažuriraj selectedWarehouse objekt
            this.selectedWarehouse = { ...warehouseData, id: docSnap.id }

            // Ažuriraj interni broj primke
            if (!deliveryCounter || deliveryCounter === 0) {
              this.interniBrojPrimke = '1'
            } else {
              this.interniBrojPrimke = deliveryCounter.toString()
            }
          }
        }, (error) => {
          console.error('Error listening to warehouse:', error)
        })
      } else if (this.selectedWarehouse && this.currentAkcija !== 'update') {
        // Fallback za kada warehouse nema ID (ne bi trebalo biti slučaj)
        const deliveryCounter = this.selectedWarehouse.delivery_counter
        if (!deliveryCounter || deliveryCounter === 0) {
          this.interniBrojPrimke = '1'
        } else {
          this.interniBrojPrimke = deliveryCounter.toString()
        }
      }
    },
    onDobavljacChange () {
      // Ako je odabrana opcija "Dodaj novog dobavljača", otvori modal
      if (this.selectedDobavljac && this.selectedDobavljac.value === 'add-new') {
        this.selectedDobavljac = null
        this.$nextTick(() => {
          this.$refs.addAssociate.open([])
        })
      }
    },
    onAssociateAdded (associate) {
      if (this.einvoiceDocumentId && associate && associate.id) {
        this.selectedDobavljac = { name: associate.name, value: associate.id, all: associate }
      }
      // Osvježi listu dobavljača nakon dodavanja novog
      if (this.dobavljacSearchInput) {
        this.searchDobavljaci(this.dobavljacSearchInput)
      }
    },
    openAddAssociate () {
      // Otvori modal za dodavanje novog dobavljača
      this.$refs.addAssociate.open([])
    },
    resetForm () {
      // Resetiraj sva polja forme na početne vrijednosti
      this.items = []
      this.brojTemelja = undefined
      this.interniBrojPrimke = undefined
      this.invoiceDate = Date.now()
      this.selectedDobavljac = undefined
      this.dobavljacSearchInput = null
      this.selectedNAcinPlacanja = undefined
      this.manualTotalsMode = false
      this.manualTotalBezPdv = null
      this.manualTotalPdv = null
      this.manualTotalSPdv = null
      this.manualInputMode = false
      this.loadedKalkulacija = null
      this.searchQuery = ''
      this.searchResults = []
      this.selectedResultIndex = 0
      this.showNoResults = false
      this.currentItem = {}
      this.editingIndex = null
      this.selectedItemIndex = -1

      // Ponovno postavi interni broj primke iz skladišta ako je odabrano
      if (this.selectedWarehouse) {
        this.$nextTick(() => {
          const deliveryCounter = this.selectedWarehouse.delivery_counter
          // Ako ne postoji ili je 0, postavi na 1
          if (!deliveryCounter || deliveryCounter === 0) {
            this.interniBrojPrimke = '1'
          } else {
            this.interniBrojPrimke = deliveryCounter.toString()
          }
        })
      }
    },
    validateIntegerInput () {
      // Osiguraj da je vrijednost cijeli broj (integer)
      if (this.interniBrojPrimke) {
        // Ukloni sve što nije broj
        const numericValue = this.interniBrojPrimke.toString().replace(/[^0-9]/g, '')
        // Ako je prazan string, postavi na 1
        if (numericValue === '' || numericValue === '0') {
          this.interniBrojPrimke = '1'
        } else {
          this.interniBrojPrimke = numericValue
        }
      }
    },
    // NAPOMENA: Ova metoda više nije potrebna jer je zamijenjena sa real-time listenerom
    // u onWarehouseChange() koji automatski ažurira delivery_counter kada se promijeni u bazi
    async refreshWarehouseFromDatabase () {
      // Listener u onWarehouseChange() automatski ažurira podatke
      // Ova metoda je ostavljena za backward compatibility ako se koristi negdje drugdje
    },
    async getItems () {
      const query = df
        .collection(`companies/${state.getCurrentCompany().id}/items`)
        .where('status', '==', 'OK')
        .where('type', '==', 'GOODS')

      const documentSnapshots = await query.get()
      if (documentSnapshots.docs && !documentSnapshots.docs.empty) {
        documentSnapshots.docs.forEach((it) => {
          const item = it.data()

          if (!item.has_norm) {
            if (item.warehouse_units?.units) {
              const map = item.warehouse_units.units
              const entries = Object.entries(map)
              entries.sort(([keyA, valueA], [keyB, valueB]) => {
                return (
                  (valueB.default_store === true) -
                  (valueA.default_store === true)
                )
              })
              const sortedMap = Object.fromEntries(entries)
              var unit = []
              for (const key in sortedMap) {
                unit.push({ label: map[key].storage_unit, value: map[key].id })
              }
              this.artikli.push({
                id: item.id,
                label: item.name,
                value: item.name,
                mjerneJedinice: unit,
                stopaPdv: item.tax_group_object?.pdv_rate ?? '',
                item: item
              })
            }
          }
        })

        var povratnaUnitId = uuidv4()

        this.artikli.push({
          id: '-1',
          label: 'Povratna naknada',
          value: 'Povratna naknada',
          mjerneJedinice: [{ label: 'kom', value: povratnaUnitId }],
          stopaPdv: '0',
          // cijena: '0.07',
          item: {
            id: '-1',
            name: 'Povratna naknada',
            selling_unit: 'kom',
            storage_unit: 'kom',
            warehouse_units: {
              base_unit: povratnaUnitId,
              default_sale: povratnaUnitId,
              default_store: povratnaUnitId,
              units: {
                [povratnaUnitId]: {
                  base_unit: true,
                  default_sale: true,
                  default_store: true,
                  id: povratnaUnitId,
                  is_selling_item: true,
                  storage_amount: 1000,
                  storage_unit: 'kom'
                }
              }
            }
          }
        })
      }
      this.artikli = this.artikli.sort((a, b) =>
        a.label.localeCompare(b.label)
      )
    },
    showReturnRefund (data) {
      var povratnaNaknada = 0
      data.forEach((item) => {
        if (item.id === '-1' && item.stopaPdv === '0') {
          povratnaNaknada += parseFloat(item.ukupnaCijenaBezPdv)
        }
      })

      if (povratnaNaknada > 0) {
        povratnaNaknada = povratnaNaknada.toFixed(2)
        return 'PN: ' + povratnaNaknada
      }

      return ''
    },
    calculateFinalAmount (data, field) {
      var iznosPdv = 0
      var ukupnaCijenaBezPdv = 0

      data = data.filter(
        (item) => !(item.id === '-1' && item.stopaPdv === '0')
      )

      switch (this.porezCalcType) {
        case 1:
          data.forEach((item) => {
            if (item.id === '-1' && item.stopaPdv === '0') {
              return
            }

            iznosPdv += parseFloat(item.iznosPdv)
            ukupnaCijenaBezPdv += parseFloat(item.ukupnaCijenaBezPdv)
          })

          if (iznosPdv > 0) {
            iznosPdv.toFixed(2)
          }

          if (ukupnaCijenaBezPdv > 0) {
            ukupnaCijenaBezPdv.toFixed(2)
          }

          break
        case 2: {
          const ukupnoSPdvPoStopi = data.reduce((acc, artikal) => {
            const stopaPdv = artikal.stopaPdv
            const ukupnaCijenaSPdv = parseFloat(artikal.ukupnaCijenaSPdv)

            if (!acc[stopaPdv]) {
              acc[stopaPdv] = 0
            }

            acc[stopaPdv] += ukupnaCijenaSPdv
            return acc
          }, {})

          const pdvInfo = Object.entries(ukupnoSPdvPoStopi).map(
            ([stopaPdv, ukupnoSPdv]) => {
              const stopa = parseFloat(stopaPdv)
              const osnovica = ukupnoSPdv / (1 + stopa / 100)
              const iznosPdv = ukupnoSPdv - osnovica

              return {
                stopaPdv: stopa,
                osnovica: osnovica.toFixed(2),
                iznosPdv: iznosPdv.toFixed(2),
                ukupnoSPdv: ukupnoSPdv.toFixed(2)
              }
            }
          )

          const ukupno = pdvInfo.reduce(
            (acc, item) => {
              acc.ukupnaCijenaBezPdv += parseFloat(item.osnovica)
              acc.ukupniPdv += parseFloat(item.iznosPdv)
              return acc
            },
            { ukupnaCijenaBezPdv: 0, ukupniPdv: 0 }
          )

          iznosPdv += ukupno.ukupniPdv
          ukupnaCijenaBezPdv += ukupno.ukupnaCijenaBezPdv
          break
        }
      }

      switch (field) {
        case 'ukupnaCijenaBezPdv':
          return ukupnaCijenaBezPdv

        case 'iznosPdv':
          return iznosPdv
      }
    }
  },
  watch: {
    selectedDobavljac (newVal) {
      // Ensure selected supplier is always in the list
      if (newVal && !this.dobavljaci.find(d => d.name === newVal.name)) {
        this.dobavljaci.push(newVal)
      }
    },
    dobavljacSearchInput: debounce(function (searchQuery) {
      // Only trigger search when user types 3+ characters
      if (searchQuery && searchQuery.trim().length >= 3) {
        this.searchDobavljaci(searchQuery.trim())
      } else if (!searchQuery || searchQuery.trim().length < 3) {
        // Očisti listu ako je pretraga kraća od 3 znaka
        this.dobavljaci = []
      }
    }, 500),
    rabatCalcType () {
      // Programska promjena (primka iz e-računa) ne smije preračunati iznose iz dijaloga
      if (this.skipNextRabatRecalc) {
        this.skipNextRabatRecalc = false
        return
      }
      // Recalculate all items when discount calculation method changes
      this.recalculateAllItems()
    },
    porezCalcType () {
      // Recalculate all items when tax calculation method changes
      this.recalculateAllItems()
    }
  },
  created () {
    window.addEventListener('resize', this.calculateHeights)
  },
  beforeDestroy () {
    if (this.listeners) {
      this.detachListeners()
    }
    // Cleanup warehouse listener
    if (this.warehouseUnsubscribe) {
      this.warehouseUnsubscribe()
      this.warehouseUnsubscribe = null
    }
    window.removeEventListener('resize', this.calculateHeights)
    document.removeEventListener('keydown', this.handleGlobalKeydown)
    // Remove beforeunload listener
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  async mounted () {
    this.margin = state.getMargin()
    EventBus.$on('set-mini', () => {
      this.margin = state.getMargin()
    })
    // Add beforeunload listener for browser refresh/close
    window.addEventListener('beforeunload', this.handleBeforeUnload)

    if (this.modal) {
      this.margin = '0px'
    }

    // Check for query parameters (id, warehouseId and akcija) to load existing document
    const documentId = this.$route.query.id
    const warehouseId = this.$route.query.warehouseId
    const akcija = this.$route.query.akcija

    if (documentId && warehouseId && akcija === 'update') {
      // Set akcija from query param
      this.currentAkcija = akcija
      // Load the kalkulacija data from Firestore
      await this.loadKalkulacijaData(documentId, warehouseId)
    } else if (this.$route.query.fromEinvoice) {
      // Load from eInvoice
      this.fromEinvoice = true
      this.einvoiceDocumentId = String(this.$route.query.fromEinvoice)
      try {
        await this.getLocations()
      } catch (error) {
        console.error('Error loading locations:', error)
        this.showMsgBox({
          text: 'Nije uspjelo učitavanje lokacija.',
          actions: ['cancel'],
          cancelBtnText: this.$t('$vuetify.close'),
          color: 'error'
        })
        this.setupKeyboardShortcuts()
        return
      }
      await this.loadFromEinvoice()
    } else {
      // Normal flow for creating new kalkulacija
      this.getLocations()
      // Dobavljaci se pretražuju trigram metodom kada korisnik počne tipkati
    }

    this.setupKeyboardShortcuts()
  }
}
</script>
<style>
.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
  white-space: normal;
  text-overflow: clip;
  text-align: center;
  font-size: small;
  font-family: Arial, sans-serif !important;
  font-size: 1em;
  color: black !important;
}

.tabulator-col {
  background-color: #f2f2f2 !important;
}

.tabulator .tabulator-row .tabulator-cell {
  font-family: Arial, sans-serif !important;
  font-size: 1em;
  color: black !important;
}

.tabulator-edit-select option {
  height: 30px;
  /* Postavite željenu visinu stavki u dropdownu */
}

/* CSS medijski upiti */
.resizable {
  width: 100%;
}

/* @media (min-width: 1200px) {
  .resizable {
    width: 95%;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .resizable {
    width: 95%;
  }
}

@media (max-width: 767px) {
  .resizable {
    width: 95%;
  }
} */

.tabulator-edit-list .tabulator-edit-list-item {
  padding: 4px;
  height: 50px;
  color: #333;
  outline: none;
  vertical-align: middle;
  font-size: 18px;
  padding: 16px 0 0 10px;
}

.butt {
  border-radius: 5px;
  border: 2px solid black;
  background-color: white !important;
  color: black;
  padding: 0px 5px 0px 5px;
  font-size: 24px;
  cursor: pointer;
  font-weight: bold;
}

.iclass {
  font-size: 20px;
  /* Veličina fonta */
  height: 30px;
  /* Visina ikone */
  line-height: 30px;
  /* Postavljanje vertikalnog centriranja */
  display: inline-flex;
  /* Omogućava postavljanje dimenzija i centriranje */
  align-items: center;
  /* Vertikalno centriranje */
  justify-content: center;
  /* Horizontalno centriranje */
  transition: color 0.3s, background-color 0.3s;
  /* Glatka tranzicija za promenu boje */
  color: black;
  /* Inicijalna boja teksta */
  background-color: white;
  /* Inicijalna pozadinska boja */
  padding: 5px;
  /* Unutrašnja margina za bolji izgled */
  border-radius: 5px;
  /* Zaobljeni uglovi */
}

/* Promena boje teksta i pozadinske boje na hover */
.iclass:hover {
  color: white;
  /* Promena boje teksta na hover */
  background-color: red;
  /* Promena pozadinske boje na hover */
}

/* Date picker field styling - STYLING.md compliant - using xmx prefix */
.datetimepicker {
  width: 100%;
}

/* Date picker wrapper - force width */
.datetimepicker.xmx-datepicker,
.datetimepicker .xmx-datepicker {
  width: 100% !important;
}

/* Date picker input wrapper - exact height match */
.datetimepicker .xmx-input-wrapper,
.xmx-datepicker .xmx-input-wrapper {
  height: 36px !important;
  min-height: 36px !important;
  max-height: 36px !important;
}

/* Date picker input field - match filter-select styling exactly */
.datetimepicker .xmx-input,
.xmx-datepicker .xmx-input,
.datetimepicker input.xmx-input {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
  padding: 0 32px 0 10px !important;
  height: 36px !important;
  line-height: normal !important;
  min-height: 36px !important;
  max-height: 36px !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
  vertical-align: middle !important;
}

.datetimepicker .xmx-input:hover,
.xmx-datepicker .xmx-input:hover {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.datetimepicker .xmx-input:focus,
.xmx-datepicker .xmx-input:focus {
  border-color: #3989C9 !important;
  border-width: 2px !important;
  outline: none !important;
  padding: 0 31px 0 9px !important;
}

/* Date picker icon positioning */
.datetimepicker .xmx-input-append,
.xmx-datepicker .xmx-input-append {
  position: absolute !important;
  right: 8px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin: 0 !important;
  height: 20px !important;
  display: flex !important;
  align-items: center !important;
}

/* Date picker icon */
.datetimepicker .xmx-icon-calendar,
.datetimepicker .xmx-icon-clear,
.xmx-datepicker .xmx-icon-calendar,
.xmx-datepicker .xmx-icon-clear {
  color: #3989C9 !important;
  font-size: 18px !important;
  line-height: 1 !important;
  width: 18px !important;
  height: 18px !important;
}

/* Date picker popup */
.xmx-datepicker-popup {
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 8px !important;
  border: 1px solid rgba(0, 179, 190, 0.15) !important;
  box-shadow: 0 8px 24px rgba(0, 179, 190, 0.12) !important;
}

/* No results overlay - positioned absolutely to avoid layout shift */
.no-results-overlay {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99998;
  margin-top: 4px;
}

/* No results alert - full opacity, solid background */
.no-results-overlay .v-alert {
  background: rgba(33, 150, 243, 1) !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4) !important;
  backdrop-filter: none !important;
}

.no-results-overlay .v-alert__icon {
  color: white !important;
}

.no-results-overlay .v-alert .v-icon {
  color: white !important;
}
</style>

<style scoped>
/* Remove card shadows on this page */
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}

.table-sm {
  margin-top: 10px;
}

.custom-list {
  padding: 0px !important;
}

.custom-list-item {
  padding-bottom: 2px !important;
  background-color: transparent;
}

.okvir-modal {
  margin-left: 0px;
  margin-right: 0px;
  display: flex;
  justify-content: center;
  /* Vodoravno centriranje */
  align-items: center;
  /* Okomito centriranje */
  border-radius: 25px !important;
}

.okvir {
  margin-left: 10px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  /* Vodoravno centriranje */
  align-items: center;
  /* Okomito centriranje */
}

/* Search in Header Styles */
.search-in-header {
  position: relative;
  z-index: 100;
}

.search-results {
  position: absolute;
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  background: white !important;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  margin-top: 4px;
  z-index: 99999;
  left: 0;
}

/* Search results header row */
.search-results-header {
  background-color: white !important;
  background-image: linear-gradient(135deg,
    rgba(0, 179, 190, 0.08) 0%,
    rgba(57, 137, 201, 0.06) 50%,
    rgba(97, 84, 164, 0.08) 100%) !important;
  cursor: default !important;
  pointer-events: none;
  min-height: 36px !important;
  position: sticky !important;
  top: 0 !important;
  z-index: 1 !important;
}

.search-results-header:hover {
  background-color: white !important;
  background-image: linear-gradient(135deg,
    rgba(0, 179, 190, 0.08) 0%,
    rgba(57, 137, 201, 0.06) 50%,
    rgba(97, 84, 164, 0.08) 100%) !important;
}

.search-result-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  transition: background-color 0.2s ease;
  min-height: 44px !important;
  background: white !important;
}

.search-result-item:last-child {
  border-bottom: none;
}

.search-result-item:hover {
  background: rgba(0, 179, 190, 0.05) !important;
  cursor: pointer;
}

.search-result-item.result-selected {
  background: rgba(0, 179, 190, 0.12) !important;
}

/* Touch Optimization - Larger targets for mobile */
@media (max-width: 768px) {
  .v-btn {
    min-height: 48px !important;
    font-size: 16px !important;
  }

  .v-text-field input {
    font-size: 16px !important;
  }

  .search-panel {
    padding: 12px;
  }

  .search-results .v-list-item {
    min-height: 56px !important;
  }
}

/* Items List Styles */
.items-list {
  padding: 0 16px 16px 16px;
  max-height: calc(100vh - 270px); /* Viewport height minus headers and footer */
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 8px;
}

.items-header-wrapper {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: white;
}

.items-header {
  background: white;
  background-image: linear-gradient(135deg,
    rgba(0, 179, 190, 0.08) 0%,
    rgba(57, 137, 201, 0.08) 50%,
    rgba(97, 84, 164, 0.08) 100%);
  border-radius: 4px;
  border-bottom: 2px solid rgba(0, 179, 190, 0.3);
}

.item-row {
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  min-height: 36px !important;
  max-height: 36px !important;
}

.item-row:hover {
  border-left-color: rgba(0, 179, 190, 0.8);
  transform: translateX(2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
  background-color: rgba(0, 179, 190, 0.02);
}

.item-row-selected {
  border-left-color: rgba(0, 179, 190, 1) !important;
  border-left-width: 4px !important;
  background-color: rgba(0, 179, 190, 0.08) !important;
  box-shadow: 0 2px 12px rgba(0, 179, 190, 0.3) !important;
}

.item-row .v-card__text {
  padding: 4px 12px !important;
  line-height: 1.2;
}

/* Fixed Actions Bar */
.fixed-actions {
  position: fixed;
  bottom: 0;
  left: 71px; /* SideNav width */
  right: 0;
  background: white;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.1);
  z-index: 5; /* Lower than SideNav submenus */
  padding: 12px 16px;
  border-top: 2px solid rgba(0, 179, 190, 0.3);
  transition: left 0.2s ease;
  min-height: 60px;
}

/* Inline Totals in Fixed Actions */
.totals-inline {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.08) 0%,
    rgba(57, 137, 201, 0.08) 50%,
    rgba(97, 84, 164, 0.08) 100%);
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid rgba(0, 179, 190, 0.2);
}

/* When sidenav is hidden (mobile) */
@media (max-width: 960px) {
  .fixed-actions {
    left: 0;
  }
}

.totals-card {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.05) 0%,
    rgba(57, 137, 201, 0.05) 50%,
    rgba(97, 84, 164, 0.05) 100%) !important;
  border: 2px solid rgba(0, 179, 190, 0.2);
}

/* Modal Gradient Header */
.gradient-header {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%);
  color: white !important;
}

.gradient-header .text-h6 {
  color: white !important;
}

/* Table Header with Filters - Sticky */
.table-header-filters {
  position: -webkit-sticky;
  position: sticky;
  top: 64px;
  z-index: 3;
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.08) 0%,
    rgba(57, 137, 201, 0.06) 50%,
    rgba(97, 84, 164, 0.08) 100%) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  padding: 12px 16px;
  margin-bottom: 0;
  box-shadow: 0 2px 12px rgba(0, 179, 190, 0.15);
  border-bottom: 2px solid rgba(0, 179, 190, 0.25);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: visible !important;
}

.table-header-filters::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: inherit;
  backdrop-filter: inherit;
  -webkit-backdrop-filter: inherit;
  z-index: -1;
}

/* Filter Select Inputs */
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  min-height: 36px !important;
  max-height: 36px !important;
  height: 36px !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined >>> .v-input__control {
  border-radius: 8px !important;
  min-height: 36px !important;
  max-height: 36px !important;
  height: 36px !important;
}

.filter-select >>> .v-input__control {
  min-height: 36px !important;
  max-height: 36px !important;
  height: 36px !important;
}

.filter-select.v-text-field--outlined >>> .v-text-field__slot {
  border-radius: 8px !important;
}

.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
}

.filter-select >>> label {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: rgba(57, 137, 201, 0.8) !important;
}

/* Filter Select Dropdown Menu */
.filter-select >>> .v-menu__content {
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 8px !important;
  border: 1px solid rgba(0, 179, 190, 0.15) !important;
  box-shadow: 0 8px 24px rgba(0, 179, 190, 0.12) !important;
}

.filter-select >>> .v-list-item {
  font-size: 13px !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
}

.filter-select >>> .v-list-item:hover {
  background: rgba(57, 137, 201, 0.08) !important;
}

.filter-select >>> .v-list-item--active {
  background: rgba(0, 179, 190, 0.12) !important;
  color: #3989C9 !important;
}

.filter-select >>> .v-simple-checkbox {
  color: #3989C9 !important;
}

/* Modal Styling - STYLING.md compliant */
.modal-glass-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.15) !important;
  overflow: hidden;
}

.modal-gradient-header {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%) !important;
  color: white !important;
  padding: 20px 24px !important;
  position: relative;
}

.modal-gradient-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    repeating-linear-gradient(45deg,
      transparent,
      transparent 10px,
      rgba(255, 255, 255, 0.03) 10px,
      rgba(255, 255, 255, 0.03) 20px);
  pointer-events: none;
}

.modal-gradient-header .text-h6 {
  position: relative;
  z-index: 1;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
}

/* Financial Summary Modal - Fixed Header & Footer */
.financial-summary-modal {
  display: flex !important;
  flex-direction: column !important;
  max-height: 90vh !important;
}

.financial-summary-header {
  flex-shrink: 0 !important;
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
}

.financial-summary-content {
  flex: 1 1 auto !important;
  overflow-y: auto !important;
  max-height: calc(90vh - 140px) !important;
}

.financial-summary-footer {
  flex-shrink: 0 !important;
  position: sticky !important;
  bottom: 0 !important;
  z-index: 10 !important;
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(10px) !important;
  border-top: 1px solid rgba(0, 179, 190, 0.15) !important;
}

/* Modal Buttons */
.modal-cancel-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: rgba(70, 70, 80, 0.9) !important;
  border: 1px solid rgba(120, 120, 130, 0.25) !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.modal-cancel-btn:hover {
  background: rgba(255, 255, 255, 1) !important;
  border-color: rgba(120, 120, 130, 0.4) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-1px);
}

.modal-save-btn {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.95) 0%,
    rgba(57, 137, 201, 0.9) 50%,
    rgba(97, 84, 164, 0.95) 100%) !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 179, 190, 0.3) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.modal-save-btn:hover {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 0.95) 50%,
    rgba(97, 84, 164, 1) 100%) !important;
  box-shadow: 0 6px 16px rgba(0, 179, 190, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px) scale(1.02);
}

.modal-save-btn .v-icon {
  color: white !important;
  font-size: 18px !important;
}

/* Footer Total Boxes - Glass-morphism Style */
.total-box {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(0, 179, 190, 0.15) !important;
  border-radius: 6px !important;
  padding: 3px 10px !important;
  box-shadow: 0 2px 8px rgba(0, 179, 190, 0.1) !important;
  min-width: 100px;
  transition: all 0.2s ease !important;
}

.total-box:hover {
  border-color: rgba(0, 179, 190, 0.25) !important;
  box-shadow: 0 3px 12px rgba(0, 179, 190, 0.15) !important;
  transform: translateY(-1px);
}

.total-label {
  font-size: 9px !important;
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.6) !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 1px;
  line-height: 1.1;
}

.total-value {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: rgba(0, 0, 0, 0.87) !important;
  letter-spacing: 0.2px;
  line-height: 1.2;
}

/* Main Total Box - Highlighted */
.total-box-main {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.08) 0%,
    rgba(57, 137, 201, 0.06) 50%,
    rgba(97, 84, 164, 0.08) 100%) !important;
  border: 1.5px solid rgba(0, 179, 190, 0.3) !important;
  box-shadow: 0 3px 12px rgba(0, 179, 190, 0.18) !important;
  min-width: 130px;
  padding: 3px 12px !important;
}

.total-box-main:hover {
  border-color: rgba(0, 179, 190, 0.45) !important;
  box-shadow: 0 4px 16px rgba(0, 179, 190, 0.25) !important;
  transform: translateY(-2px) scale(1.02);
}

.total-label-main {
  font-size: 10px !important;
  font-weight: 700 !important;
  color: rgba(0, 179, 190, 0.9) !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 1px;
  line-height: 1.1;
}

.total-value-main {
  font-size: 16px !important;
  font-weight: 800 !important;
  background: linear-gradient(135deg, #00B3BE 0%, #3989C9 50%, #6154A4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

/* Delete Button in Table Row */
.kalkulacija-delete-btn {
  background: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(244, 67, 54, 0.2) !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 6px rgba(244, 67, 54, 0.12) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  width: 32px !important;
  height: 32px !important;
}

.kalkulacija-delete-btn:hover:not(:disabled) {
  background: rgba(244, 67, 54, 0.08) !important;
  border-color: rgba(244, 67, 54, 0.35) !important;
  box-shadow: 0 3px 10px rgba(244, 67, 54, 0.2) !important;
  transform: scale(1.05);
}

.kalkulacija-delete-btn .v-icon {
  color: #F44336 !important;
  font-size: 18px !important;
}

/* Footer Action Buttons - STYLING.md Compliant */

/* Success Button (Spremi) */
.kalkulacija-success-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #4CAF50 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(76, 175, 80, 0.15) !important;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 0 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.kalkulacija-success-btn:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.25) !important;
  border-color: rgba(76, 175, 80, 0.3) !important;
  transform: translateY(-1px);
}

.kalkulacija-success-btn .v-icon {
  color: #4CAF50 !important;
  font-size: 18px !important;
}

/* Danger Button (Obriši sve) */
.kalkulacija-danger-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #F44336 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(244, 67, 54, 0.15) !important;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 0 20px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.kalkulacija-danger-btn:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.25) !important;
  border-color: rgba(244, 67, 54, 0.3) !important;
  transform: translateY(-1px);
}

.kalkulacija-danger-btn .v-icon {
  color: #F44336 !important;
  font-size: 18px !important;
}

/* Cancel Button (Odustani) */
.kalkulacija-cancel-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #F44336 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(244, 67, 54, 0.15) !important;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  padding: 0 18px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.kalkulacija-cancel-btn:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.25) !important;
  border-color: rgba(244, 67, 54, 0.3) !important;
  transform: translateY(-1px);
}

.kalkulacija-cancel-btn .v-icon {
  color: #F44336 !important;
  font-size: 18px !important;
}

.total-box-warning {
  background: rgba(255, 243, 224, 0.85) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(251, 140, 0, 0.25) !important;
  border-radius: 6px !important;
  padding: 3px 10px !important;
  box-shadow: 0 2px 8px rgba(251, 140, 0, 0.1) !important;
  min-width: 100px;
  transition: all 0.2s ease !important;
}

.total-box-warning:hover {
  border-color: rgba(251, 140, 0, 0.4) !important;
  box-shadow: 0 3px 12px rgba(251, 140, 0, 0.18) !important;
  transform: translateY(-1px);
}

.total-box-warning .total-label {
  font-size: 9px !important;
  font-weight: 600 !important;
  color: #FB8C00 !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 1px;
  line-height: 1.1;
}

.total-box-warning .total-value {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #F57C00 !important;
  letter-spacing: 0.2px;
  line-height: 1.2;
}

/* Modal Fixed Layout - Header and Footer Always Visible */
.modal-fixed-layout {
  display: flex !important;
  flex-direction: column !important;
  max-height: 85vh !important;
}

.modal-fixed-header {
  flex-shrink: 0 !important;
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
}

.modal-scrollable-content {
  flex: 1 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-height: calc(85vh - 120px) !important;
}

.modal-fixed-footer {
  flex-shrink: 0 !important;
  position: sticky !important;
  bottom: 0 !important;
  background: white !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
  z-index: 10 !important;
}

/* Manual Total Input Styles */
.manual-total-input {
  margin-top: 4px !important;
}

.manual-total-input .v-input__control {
  min-height: 32px !important;
}

.manual-total-input .v-text-field__prefix {
  margin-top: 2px !important;
  font-weight: 600;
  color: #1976D2 !important;
}

.manual-total-input input {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #1976D2 !important;
  text-align: right;
}

/* Retail Price Field Styles */
.retail-price-field >>> .v-input__slot {
  background: rgba(33, 150, 243, 0.05) !important;
}

.retail-price-field >>> fieldset {
  border-color: rgba(33, 150, 243, 0.3) !important;
}

.retail-price-field >>> .v-text-field__prefix {
  color: #2196F3 !important;
  font-weight: 600;
}

.retail-price-field >>> input {
  color: #1976D2 !important;
  font-weight: 500;
}

.manual-total-input.font-weight-bold input {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #1565C0 !important;
}

.manual-total-input .v-input__slot {
  background-color: #E3F2FD !important;
  border-color: #1976D2 !important;
}

.manual-total-input.v-input--is-focused .v-input__slot {
  background-color: #BBDEFB !important;
  border-color: #1565C0 !important;
  border-width: 2px !important;
}

/* Margin Positive Field Styles */
.margin-positive-field >>> .v-input__slot {
  background: rgba(76, 175, 80, 0.08) !important;
}

.margin-positive-field >>> fieldset {
  border-color: rgba(76, 175, 80, 0.4) !important;
}

.margin-positive-field >>> .v-text-field__suffix {
  color: #4CAF50 !important;
  font-weight: 600;
}

.margin-positive-field >>> input {
  color: #2E7D32 !important;
  font-weight: 600;
}

/* Margin Negative Field Styles */
.margin-negative-field >>> .v-input__slot {
  background: rgba(244, 67, 54, 0.08) !important;
}

.margin-negative-field >>> fieldset {
  border-color: rgba(244, 67, 54, 0.4) !important;
}

.margin-negative-field >>> .v-text-field__suffix {
  color: #F44336 !important;
  font-weight: 600;
}

.margin-negative-field >>> input {
  color: #C62828 !important;
  font-weight: 600;
}
</style>
